// CONST
var SobertrackIconIdValue ={
    1:'Enrollee failed. Not reviewed',
    10:'Sobertrack passed. Not reviewed',
    4:'Sobertrack failed. Image failed',
    13:'Sobertrack passed. Image failed',
    2:'Sobertrack failed. Image Matched',
    11:'Sobertrack passed. Image Matched',
    0:'pending'
};
var SoberTrackIconToStyleIcon ={
    141:'10',
    151:'11',
    161:'13',
    171:'04',
    181:'02',
    191:'01',
    201:'00',//Pending
};

//  SOBERTRACK SCHEDULES PROCESSING
function mStateManagerEnrolleesSecondarySoberTrackSchedules_Init() {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;
    if (mStateManager.Settings()[0] === 'Victims') {
        lEnrolleeId = mEnrolleesData.VictimCurrentId;
    }
    uEnrolleesSoberTrackSchedulesListView_Init();
    EnrolleeProfileSoberTrackSchedules_Init(lEnrolleeId);

}

function uQuickReviewAlcoholMonitoring(aEvent, aStateMangerHash) {
    "use strict";

    var lButtonBar = GenerateButtonCommandBar(),
        lTitle = localizeText('cSoberTrackReviewTitle') + " - " + aEvent.ScheduleTypeName + "",
        lIsDashboard = null,
        lEnrollee = getDataItem(aEvent.EnrolleeId, 'Enrollees'),
        lVideoPermission = gUserPermissions[252],
        lImageId = aEvent.ImageId;

    if (!isNullOrUndefined(aStateMangerHash) && aStateMangerHash.Tab == "Dashboard") {
        lIsDashboard = true;
        lButtonBar.append(GenerateButton('Previous Enrollee', 'FloatLeft Previous', 'navigateToPreviousEnrolleeResult()'));
        lButtonBar.append(GenerateButton('Next Enrollee', 'FloatRight Next', 'navigateToNextEnrolleeResult()'));
    } else if (!isNullOrUndefined(aStateMangerHash) && aStateMangerHash.Tab == "Enrollees") {
        if (aStateMangerHash.Settings.length > 0 && aStateMangerHash.Settings[aStateMangerHash.Settings.length - 1] == "SoberTrackSchedules") {
            lIsDashboard = true;
            lButtonBar.append(GenerateButton('Previous Test', 'FloatLeft Previous', 'navigateToPreviousEnrolleeResultSched()'));
            lButtonBar.append(GenerateButton('Next Test', 'FloatRight Next', 'navigateToNextEnrolleeResultSched()'));
        }
        
    }else {
        lButtonBar.append(GenerateButton(localizeWrapper('cSoberTrackLiveSchedule'), 'Live Schedule', 'uSoberTrackScheduleButtonInModal_OnClick()'));
    }
    lButtonBar.append(GenerateButton(localizeWrapper('cSoberTrackOnDemandCreate'), 'On Demand Event Created', 'createSoberTrackOnDemand()'));

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeConfirmReview'), 'Confirm', 'sobertrackConfirmResults()'));
    if (checkOrganizationProperty(lEnrollee.OrganizationId, 'enable_sobertrack_video') == "Y" && !isNullOrUndefined(lVideoPermission) && (lVideoPermission.Value == 1 || lVideoPermission.Value == 2)) {   
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeRetriedVideo'), 'ConsumerPreviewDisabled SobertrackRetrieveVideo', 'showRequestSoberTracakVideo()'));    
    }

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeGetVideo'), 'ConsumerPreviewDisabled SobertrackDownloadVideo', 'getSobertrackVideoResults()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cOk'), 'ConsumerPreviewDisabled SobertrackRetrieveSendVideoOk', 'sendRetrieveSobertrackVideoResults()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'ConsumerPreviewDisabled SobertrackRetrieveSendVideoCancel', 'disposeSobertrackRetrieve()'));

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeTestSummary'), 'ConsumerPreviewDisabled Summary', 'soberTrackDetailDispose(' + lIsDashboard + ')'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeTestResults'), 'Results', 'showSobertTrackTestResults()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEventViewNotes'), 'Notes', 'notesSoberTrackReviewMonitoring()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'ClosePopup()'));

    DisplayPopup(lTitle, '<div id="uSoberTrackReviewPopupHolder"></div>', lButtonBar, false, true);


    populateElement('uSoberTrackReviewPopupHolder', 'SoberTrack.Review.Popup.htm', SoberTrackReview_Init, { 'event': aEvent, 'isDashboard': lIsDashboard });
}

function GetSoberTrackLastCompleatedTestCheckByEnrolleeId(aId,aOrganizationId){
    var lBuilder = new SumoPredicateBuilder(),
    lSort = new SortExpression(),
    lLastCheck = '',
    lOffenderAlcoholSchedules = Object.assign([], gAlcoholLastTest),
    lAlcoholAssignments = getDataItems('AlcoholDeviceAssignments'),
    lEnrolleAlcoholSchedule = null;
    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional('EnrolleeId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StatusId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());

    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    // lBuilder.AddNewExpressionConditional('ScheduleType', [201, 301, 401], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lEnrolleAlcoholSchedule = query(lOffenderAlcoholSchedules, lBuilder.RootExpression);
    lSort.addDescendingColumn('StartDate');
    lEnrolleAlcoholSchedule = lSort.sort(lEnrolleAlcoholSchedule);
    var lSelectedAlcoholSchedule;
    for (var key in lEnrolleAlcoholSchedule) {
        if (lEnrolleAlcoholSchedule.hasOwnProperty(key)) {
            var isCompletedTest = false;
            if(lEnrolleAlcoholSchedule[key]['StatusId'] === 0){
                isCompletedTest = true;
                //MaxNumberRetest= TotalCheck,  NumberRetest = CheckNumber
            }else if( lEnrolleAlcoholSchedule[key]['TotalCheck'] === lEnrolleAlcoholSchedule[key]['CheckNumber']) {
                isCompletedTest = true;
            }
            if(isCompletedTest){
                lSelectedAlcoholSchedule = lEnrolleAlcoholSchedule[key];
                break;
            }
        }
    }
    return lSelectedAlcoholSchedule;
    
}
function GetSoberTrackLastTestByEnrolleeId(aId,aOrganizationId){
    var lBuilder = new SumoPredicateBuilder(),
    lSort = new SortExpression(),
    lOffenderAlcoholSchedules = Object.assign([], gAlcoholLastTest),
    lAlcoholAssignments = getDataItems('AlcoholDeviceAssignments'),
    lEnrolleAlcoholSchedule = null;
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('EnrolleeId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StatusId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    // lBuilder.AddNewExpressionConditional('ScheduleType', [201, 301, 401], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lEnrolleAlcoholSchedule = query(lOffenderAlcoholSchedules, lBuilder.RootExpression);
    lSort.addDescendingColumn('StartDate');
    lEnrolleAlcoholSchedule = lSort.sort(lEnrolleAlcoholSchedule);
    for (var key in lEnrolleAlcoholSchedule) {
        if (lEnrolleAlcoholSchedule.hasOwnProperty(key)) {
            lSelectedAlcoholSchedule = lEnrolleAlcoholSchedule[key];
            break;
        }
    }
    if(aOrganizationId){
        var OffenderAlcoholRetestMax = checkOrganizationProperty(aOrganizationId, "alcohol_number_of_retests");
        OffenderAlcoholRetestMax ++;
        lBuilder.AddNewExpressionConditional('NumberRetest', OffenderAlcoholRetestMax, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());    
    }
    if(lEnrolleAlcoholSchedule[0]){
        if((lEnrolleAlcoholSchedule[0].NumberRetest < OffenderAlcoholRetestMax) && [3, 4, 5].indexOf(lEnrolleAlcoholSchedule[0].StatusId) !== -1){
            lLastCheck = ' (In Progress)';
            lEnrolleAlcoholSchedule[0]['isCompleated'] = true;
        }else {
            lEnrolleAlcoholSchedule[0]['isCompleated'] = false
        }
    }

    return lEnrolleAlcoholSchedule[0];
    
}
function GetSoberTrackDetailById(aId, aEnrolleeId, aCallback){
    var lBuilder = new SumoPredicateBuilder(),
    lSort = new SortExpression(),    
    lOffenderAlcoholeImages = getDataItems('OffenderAlcoholImages'),
    lAlcoholAssignments = getDataItems('AlcoholDeviceAssignments'),
    lEnrolleAlcoholSchedule = null;

    GetOffenderAlcoholSchedules(aEnrolleeId, aId, function (aParams, aData) {
        lBuilder.Clear();
        //lBuilder.AddNewExpressionConditional('Id', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('StatusId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        // lBuilder.AddNewExpressionConditional('ScheduleType', [201, 301, 401], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lEnrolleAlcoholSchedule = query(aData, lBuilder.RootExpression);
        lSort.addDescendingColumn('StopDate');
        lEnrolleAlcoholSchedule = lSort.sort(lEnrolleAlcoholSchedule);

        for (var key in lEnrolleAlcoholSchedule) {
            if (lEnrolleAlcoholSchedule.hasOwnProperty(key)) {
                lSelectedAlcoholSchedule = lEnrolleAlcoholSchedule[key];
                break;
            }
        }
        aCallback(lEnrolleAlcoholSchedule[0]);        
    }, function (a,b) {
        mActivityNotification.addNotification('No Data Found');
    });
    
}
function enrolleesSoberTrackTestDetailIcon_OnClick(TestId, aEnrolleeId){
    GetSoberTrackDetailById(TestId,aEnrolleeId, function (aEvent) {
        var lFixDateData = [aEvent];
        FixDates(lFixDateData);
        // console.log('Selected Sobertrack',aEvent,TestId)
        uQuickReviewAlcoholMonitoring(lFixDateData[0]);
    });    
}


function soberTrackDetailDispose(isDashboard) {
    "use strict";
    if(mEnrolleesControls.SoberTrackTestResultControl){
        mEnrolleesControls.SoberTrackTestResultControl.dispose();

    }
    $("#uSoberTrackTestResultContentHolder").hide();
    $("#uSoberTrackReviewContentHolder").show();
    $('.SummaryButton').addClass('ConsumerPreviewDisabled');
    $('.ResultsButton').show();
    $('.NotesButton').show();
    $('.SobertrackDownloadVideoButton').addClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveVideoButton').addClass('ConsumerPreviewDisabled');

    if (!isNullOrUndefined(mEnrolleesData.CurrentAlcoholSchedule) && mEnrolleesData.CurrentAlcoholSchedule.ConfirmFlag == 0) {
        $('.ConfirmButton').show();
    } else {
        $('.ConfirmButton').hide();
    }

    if (!isNullOrUndefined(isDashboard)) {
        if (mStateManager.Hash().Tab == "Enrollees") {
            enableLiveTileNavigationButtons();
        } else {
            enableNaviationButtons(mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId);
        }
    }
}

function SoberTrackReview_Init(aParams) {
    "use strict";
    var lHideBAC = veritracks.core.GetOriProperty(aParams.event.OrganizationId, 'hide_bac_level');
    // Hide Passed or Missed test
    if(lHideBAC && [0,2].indexOf(aParams['event']['StatusId'])> -1 ){
        document.getElementById("uSoberTrackReviewBAC").remove()
    }
    var lBuilder = new SumoPredicateBuilder(),
        lTimeZone = getEnrolleeTimeZone(aParams.event.EnrolleeId),
        lEnrolleeId = aParams.event.EnrolleeId,
        lImageId = aParams.event.ImageId,
        lStartDate = new Date(moment(aParams.event.StartDate)),
        lKey;
        
    $('.Popup2').addClass('SobertrackWidth');
    mEnrolleesData.CurrentAlcoholSchedule = aParams.event;

    if (!isNullOrUndefined(aParams.isDashboard)) {
        if (mStateManager.Hash().Tab == "Enrollees") {
            enableLiveTileNavigationButtons();
        } else {
            enableNaviationButtons(lEnrolleeId);
        }

    }

    lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ImageId', lImageId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StartDate', lStartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And())
    ReadMultiple(gObjectList.OffenderAlcoholImage.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderAlcoholImage_OnSuccess, offenderAlcoholImage_OnFail, aParams, null, 0, true);

}

function offenderAlcoholImage_OnSuccess(aParams, aData) {
    "use strict";
    SoberTrackReview_Populate(aParams, aData);
}

function offenderAlcoholImage_OnFail(aParams, aData) {
    "use strict";
}

function SoberTrackReview_Populate(aParams, aData) {
    "use strict";
    /*UI Components*/
    var lEvent = aParams.event,      
        lIsStop = null,
        lCurrentUser,
        lImage = aData;

    var lTestDateUI = $('#uSoberTrackReviewTestDate span#data'),
        lResultUI = $('#uSoberTrackReviewResult span#data'),
        lReviewImgMatchUI = $('#uSoberTrackReviewImgMatch span#data'),
        lReviewBACUI = $('#uSoberTrackReviewBAC span#data'),
        lReviewRetriesUI = $('#uSoberTrackReviewRetries span#data'),
        lReviewFileImageUI = $('#uOffenderSoberTrackProfilePhoto'),
        lReviewUploadedImageUI = $('#uOffenderSoberTrackUploadedImage'),
        lReviewDateUI = $('#uSoberTrackReviewReviewDate span#data'),
        lReviewedUI = $('#uSoberTrackReviewReviewed span#data'),
        lResultsUI = $('#uSoberTrackReviewResults span#data'),
        lPreviewNotes = $('#uSoberTrackReviewPreviewNotes span#data'),
        lEnrolleeImageMatchSection = $('#uQuickSoberTrackReviewImages'),
        lTestConfirmedDateUI = $('#uSoberTrackReviewDateTestConfirmed span#data'),
        lTestConfirmedUserUI = $('#uSoberTrackReviewTestConfimredBy span#data');
    

    var lOffenderTestResultDisplay = new OffenderSoberTrackResultDisplay(lImage, lEvent);
    // MAP 
    if(lEvent.Latitude){
        var HTMLdd = ['<img style="width: 100%;" onclick="" src="https://maps.googleapis.com/maps/api/staticmap?center=',
        lEvent.Latitude,',',lEvent.Longitude,
                    '&zoom=13&size=320x200&maptype=roadmap&markers=color:blue%7Clabel:%7C',
                    lEvent.Latitude,',',lEvent.Longitude,
                    '&key=AIzaSyBogQZ182q-Y95b8DOoUUwPsu7atziovIM" />'].join('');
        document.getElementById('uSoberTrackReviewPreviewMap').innerHTML = HTMLdd;
    }
    
    lTestDateUI.html(lOffenderTestResultDisplay.TestDate);
    lResultUI.html(lOffenderTestResultDisplay.MonitoringTestResult);

    if (!isNullOrUndefined(lEvent)) {
        if (lEvent.StatusId != 0) {
            lResultUI.css('color', 'red');
        } else {
            lResultUI.css('color', 'green');
        }
    }


    lReviewImgMatchUI.html(lOffenderTestResultDisplay.EnrolleeImageMatch);
    if (lOffenderTestResultDisplay.EnrolleeImageMatch.indexOf("Failed") !== -1) {
        lReviewImgMatchUI.css('color', 'red');
    } else if (lOffenderTestResultDisplay.EnrolleeImageMatch.indexOf("Passed") !== -1) {
        lReviewImgMatchUI.css('color', 'green');
    } else {
        lReviewImgMatchUI.css('color', '#757575');
    }

    lReviewBACUI.html(lOffenderTestResultDisplay.Bac);
    lReviewRetriesUI.html(lOffenderTestResultDisplay.NumberRetries);
    lReviewDateUI.html(lOffenderTestResultDisplay.DateOfReview);
    lReviewedUI.html(lOffenderTestResultDisplay.ReviewedBy);
    lPreviewNotes.html(lOffenderTestResultDisplay.Notes);
    lResultsUI.html(lOffenderTestResultDisplay.Results);
    lTestConfirmedDateUI.html(lOffenderTestResultDisplay.TestConfirmedDate);
    lTestConfirmedUserUI.html(lOffenderTestResultDisplay.TestConfirmedBy);
 
    lReviewUploadedImageUI.attr('src', lOffenderTestResultDisplay.UploadedFile);
    if (lOffenderTestResultDisplay.UploadedFile == 'Images/NoPhoto.png') {
        //lReviewUploadedImageUI.removeClass('AlcoholUploadedImage');
        lReviewUploadedImageUI.css('padding', '0px');
    } else {
        //lReviewUploadedImageUI.css('padding', '10px');
    }

    generateSoberTrackOffenderPhoto({ 'EnrolleeId': lOffenderTestResultDisplay.EnrolleeId, 'UI': 'uOffenderSoberTrackProfilePhoto' });

    //if (lEvent.StatusId == 2){
        //$('.ResultsButton').hide();
    //}

    if (isNullOrUndefined(mEnrolleesData.CurrentAlcoholImage)) {
        $('.MatchButton').hide();
        $('.FailButton').hide();
    } else {

        $("#uSoberTrackAlcoholPhotoNumberContainer").show();
        if (mEnrolleesData.CurrentAlcoholImage.Id == -1) {
            $('.MatchButton').hide();
            $('.FailButton').hide();
        } else {
            //if (mEnrolleesData.CurrentAlcoholImage.ImageMatchedFlag >= 0) {
            //    lIsStop = isNullOrUndefined(getDataItem(mEnrolleesData.CurrentAlcoholImage.AppUserId, 'Agents'));
            //    lCurrentUser = isNullOrUndefined(getDataItem(gUserDetails.UserId, 'Agents'));
            //    if (lIsStop && !lCurrentUser) {
            //        $('.MatchButton').show();
            //        $('.FailButton').show();
            //    } else if (!lCurrentUser) {
            //        $('.MatchButton').show();
            //        $('.FailButton').show();
            //    } else {
            //        $('.MatchButton').hide();
            //        $('.FailButton').hide();
            //    }               
            //} else {
            //    $('.MatchButton').show();
            //    $('.FailButton').show();
            //}

            $('.MatchButton').show();
            $('.FailButton').show();
            $('#uSobertTrackUploadSetImage').show();
        }
    }//end of if

    if (mEnrolleesData.CurrentAlcoholSchedule.ConfirmFlag == -1 || mEnrolleesData.CurrentAlcoholSchedule.ConfirmFlag == 0) {
        $('.ConfirmButton').show();
    } else {
        $('.ConfirmButton').hide();
    }

}

function renderGeneratedOffenderPhotosTestResults(aUId, aPhotoUri) {
    $('#' + aUId).attr('src', aPhotoUri);
}
function OffenderSoberTrackResultDisplay(aImage, aEvent) {
    "use strict";
    var lImage = new OffenderAlcoholImage(),
        lAgents = getDataItems('Agents'),
        lAgent = null,
        lBuilder = new SumoPredicateBuilder(),
        lEnrollee = getDataItem(aEvent.EnrolleeId, 'Enrollees'),
        lTimeZone = getEnrolleeTimeZone(aEvent.EnrolleeId),
        lNumRetestMax = parseInt(checkOrganizationProperty(lEnrollee.OrganizationId, "alcohol_number_of_retests"));
    lNumRetestMax++;
    var lImagePath = veritracks.system.clientSetting("alcoholimagefolder");
    if (!isNullOrUndefined(aEvent.StopDate)) {
        if(!isNullOrUndefined(aEvent.EventStart)){
            this.TestDate = DisplayShortDateTime(new Date(moment.utc(aEvent.StartDate)));
        }else {
            this.TestDate = displayEnrolleeTimeZoneFormatted(aEvent.StartDate, lTimeZone); 
        }
    } else {
        this.TestDate = "No Test Date";
    }

    if (Array.isArray(aImage) && aImage.length > 0) {
        lImage = aImage[0];
    }

    this.EnrolleeId = aEvent.EnrolleeId;
    this.MonitoringTestResult = aEvent.StatusName; //convert to display with function
    this.EnrolleeImageMatch = getImageMatchDisplay(lImage.ImageMatchedFlag); //need button to confirm image matches
    this.Bac = aEvent.Bac / 1000;
    this.NumberRetries = aEvent.NumberRetest;
    //this.PictureOnFile = generateSoberTrackOffenderPhoto(aEvent.EnrolleeId);
    this.PictureOnFile = 'Images/NoPhoto.png';
    if (isNullOrUndefined(lImage.DeviceImageUrl)) {
        if (aEvent.StatusId != 2 && aEvent.StatusId != 3 && aEvent.StatusId != 4) {
            this.UploadedFile = 'Images/PendingPhoto.png';
        } else {
            this.UploadedFile = 'Images/NoPhoto.png';
        }
        
    } else {
       // $('#figCaptionNoPhoto').hide();
        this.UploadedFile = lImagePath + lImage.DeviceImageUrl;
    }


    this.DateOfReview = 'None'
    this.ReviewedBy = lImage.AppUserId; //function to display name of person reviewed by
    this.Results = lImage.ValidatedFlag; //function to change validation and button
    this.Notes = lImage.Notes; //display text and button if notes exist

    if (isNullOrUndefined(this.Bac)) {
        this.Bac = 'Not Set';
    }

    if (!isNullOrUndefined(lImage) && lImage.AppUserId == 1) {
        this.ReviewedBy = 'System';

        if (lImage.ImageMatchedFlag == 1) {
            this.EnrolleeImageMatch = 'Passed (System)';
        }
       
    } else if (isNullOrUndefined(this.ReviewedBy) || this.ReviewedBy == 0 || this.ReviewedBy == -1) {
        this.ReviewedBy = 'None';
    } else {
        this.ReviewedBy = UserNameTagFormatter(this.ReviewedBy);

        if (this.ReviewedBy == '') {
            this.ReviewedBy = 'Unknown';
        }
    }    
   
    if (!isNullOrUndefined(lImage.ConfirmedDate) && moment.utc(lImage.ConfirmedDate)._d.getYear() > 0) {
        var aConfirmImageDate = displayFixedTimeZoneTime(new Date(moment.utc(lImage.ConfirmedDateUTC)), lTimeZone.TimeZoneName);
        this.DateOfReview = DisplayShortDateTime(aConfirmImageDate);
        this.Results = 'Reviewed';
    } else {
        this.Results = 'Not Reviewed';
    }
    

    if (aEvent.ConfirmFlag == 1 && !isNullOrUndefined(aEvent.ConfirmedDate)) {
        this.TestConfirmedDate = displayEnrolleeTimeZoneFormatted(new Date(moment.utc(fixDate(aEvent.ConfirmedDate))), lTimeZone);
    } else {
        this.TestConfirmedDate = '';
    }

    if (isNullOrUndefined(aEvent.ConfirmedByUserId) || aEvent.ConfirmedByUserId == 0 || aEvent.ConfirmedByUserId == -1) {
        this.TestConfirmedBy = 'None';
    } else {
        this.TestConfirmedBy = UserNameTagFormatter(aEvent.ConfirmedByUserId);

        if (this.TestConfirmedBy == '') {
            this.TestConfirmedBy = 'Unknown';
        }
    }

    if (aEvent.StatusId != 0) {
        this.NumberRetries = this.NumberRetries + "/" + lNumRetestMax;
    }


    if (lImage.Id != -1) {
        mEnrolleesData.CurrentAlcoholImage = lImage;
    } else {
        mEnrolleesData.CurrentAlcoholImage = null;
    }

    if (this.NumberRetries == -1) {
        this.NumberRetries = 'N/A';
    }

    mEnrolleesData.CurrentAlcoholSchedule = aEvent;
    mEnrolleesData.CurrentAlcoholSchedule.__type = "OffenderAlcoholSchedule:www.veritracks.com";

}

function sobertrackConfirmResults() {
    "use strict";
    //if ($(".ConfirmButton").hasClass("DisabledButtons")) {
    //    return;
   // }

    var lUpdatedSched = new OffenderAlcoholSchedule();
    lUpdatedSched.ConfirmFlag = 1;
    lUpdatedSched.Id = mEnrolleesData.CurrentAlcoholSchedule.Id;
    lUpdatedSched.ConfirmedByUserId = gUserDetails.UserId;
    lUpdatedSched.ConfirmedDate = new Date();
    lUpdatedSched.ImageId = mEnrolleesData.CurrentAlcoholSchedule.ImageId;
    lUpdatedSched.EnrolleeId = mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId;
    lUpdatedSched.ScheduleType = mEnrolleesData.CurrentAlcoholSchedule.ScheduleType;
    mEnrolleesData.CurrentAlcoholSchedule.ConfirmFlag = 1;
    mEnrolleesData.CurrentAlcoholSchedule.ConfirmedByUserId = gUserDetails.UserId;
    mEnrolleesData.CurrentAlcoholSchedule.ConfirmedDate = new Date();
    WriteSingle(lUpdatedSched, SoberTrackConfirmReview_OnSuccess, SoberTrackConfirmImageMatch_OnFailure, null);
}

function SoberTrackConfirmReview_OnSuccess(aParams, aData) {
    "use strict";
    var lAgentName = UserNameTagFormatter(gUserDetails.UserId),
        lTimeZone = getEnrolleeTimeZone(aData.EnrolleeId),
        lTestConfirmedDateUI = $('#uSoberTrackReviewDateTestConfirmed span#data'),
        lTestConfirmedUserUI = $('#uSoberTrackReviewTestConfimredBy span#data');

    
    if (lAgentName == '') {
        lTestConfirmedUserUI.html('Unknown');
    } else {
        lTestConfirmedUserUI.html(lAgentName);
    }

    var aConfirmImageDate = displayFixedTimeZoneTime(new Date(moment.utc()), lTimeZone.TimeZoneName);
    lTestConfirmedDateUI.html(DisplayShortDateTime(aConfirmImageDate));
    $('.ConfirmButton').hide();

    var viewEvents = $('#uSoberTrackLiveChart').fullCalendar('getView');
    if(!isNullOrUndefined(viewEvents.start)){
        events_SoberTracksLiveChart(viewEvents.start, viewEvents.end, viewRender_SoberTracksLiveChart);
    }
   
    if (!isNullOrUndefined(gDashboardPage)) {
        gDashboardPage.triggerOnFilter();
    }
}

function SoberTrackConfirmImageMatch_OnFailure(a, b) {
    "use strict";
}

function soberTrackConfirmImageMatch() {
    "use strict";

    if (!isNullOrUndefined(mEnrolleesData.CurrentAlcoholImage)) {
        mEnrolleesData.CurrentAlcoholImage.ValidatedFlag = 1;
        mEnrolleesData.CurrentAlcoholImage.ImageMatchedFlag = 1;
        if (isNullOrUndefined(mEnrolleesData.CurrentAlcoholImage.AppUserId) || mEnrolleesData.CurrentAlcoholImage.AppUserId == -1) {
            mEnrolleesData.CurrentAlcoholImage.AppUserId = gUserDetails.UserId;
        }
        mEnrolleesData.CurrentAlcoholImage.AppUserId = gUserDetails.UserId;
        WriteSingle(mEnrolleesData.CurrentAlcoholImage, SoberTrackConfirmImageMatch_OnSuccess, SoberTrackConfirmImageMatch_OnFailure, null);
    }

}

function soberTrackConfirmImageFail() {
    "use strict";
    if (!isNullOrUndefined(mEnrolleesData.CurrentAlcoholImage)) {
        mEnrolleesData.CurrentAlcoholImage.ValidatedFlag = 1;
        mEnrolleesData.CurrentAlcoholImage.ImageMatchedFlag = 0;
        //if (isNullOrUndefined(mEnrolleesData.CurrentAlcoholImage.AppUserId) || mEnrolleesData.CurrentAlcoholImage.AppUserId == -1) {
        mEnrolleesData.CurrentAlcoholImage.AppUserId = gUserDetails.UserId;
        //}
        WriteSingle(mEnrolleesData.CurrentAlcoholImage, SoberTrackConfirmImageMatch_OnSuccess, SoberTrackConfirmImageMatch_OnFailure, null);
    }
}

function SoberTrackConfirmImageMatch_OnSuccess(aParams, aData) {
    "use strict";
    var lReviewImgMatchUI = $('#uSoberTrackReviewImgMatch span#data'),
        lReviewedUI = $('#uSoberTrackReviewReviewed span#data'),
        lReviewDateUI = $('#uSoberTrackReviewReviewDate span#data'),
        lTimeZone = getEnrolleeTimeZone(aData.EnrolleeId),
        lIsStop,
        lCurrentUser,
        lResultsUI = $('#uSoberTrackReviewResults span#data');

    if (aData.ImageMatchedFlag == 1) {
        lReviewImgMatchUI.html("Passed (Agent)");
        lReviewImgMatchUI.css('color', 'green');
    } else {
        lReviewImgMatchUI.html("Failed (Agent)");
        lReviewImgMatchUI.css('color', 'red');
    }

    var aConfirmImageDate = displayFixedTimeZoneTime(new Date(moment.utc()), lTimeZone.TimeZoneName);
    lReviewDateUI.html(DisplayShortDateTime(aConfirmImageDate));
    lReviewedUI.html(gUserDetails.FullName);
    lResultsUI.html('Reviewed');
    //lIsStop = isNullOrUndefined(getDataItem(mEnrolleesData.CurrentAlcoholImage.AppUserId, 'Agents'));
    //lCurrentUser = isNullOrUndefined(getDataItem(gUserDetails.UserId, 'Agents'));
    //if (lIsStop && !lCurrentUser) {
    //    $('.MatchButton').show();
    //    $('.FailButton').show();
    //} else if (!lCurrentUser) {
    //    $('.MatchButton').show();
    //    $('.FailButton').show();
    //} else {
    //    $('.MatchButton').hide();
    //    $('.FailButton').hide();
    //}

    $('.MatchButton').show();
    $('.FailButton').show();
   


    //setDataItem(mEnrolleesData.CurrentAlcoholImage.Id, 'OffenderAlcoholImages', mEnrolleesData.CurrentAlcoholImage);

    sobertrackConfirmResults();

    if (!isNullOrUndefined(gDashboardPage)) {
        gDashboardPage.triggerOnFilter();
    }
}

function getImageMatchDisplay(imageMatchedFlag) {
    "use strict";
    if (imageMatchedFlag === 1) {
        return localizeText('cSoberTrackPassed');
    } else if (imageMatchedFlag === -1) {
        return localizeText('cSoberTrackNotValidated');
    } else {
        return localizeText('cSoberTrackFailed');
    }
}

function getTestResultDescription(aStatusId) {
    "use strict";
    if (aStatusId == 0) {
        return localizeText('cSoberTrackPassed');
    } else {
        return localizeText('cSoberTrackFailed');
    }
}

function getCorrectTestResultId(aStatusId) {
    "use strict";
    if (aStatusId == 0) {
        return 'pass';
    } else {
        return 'fail';
    }
}

function getSoberTrackReviewingAgent() {
    "use strict";
    var lSelectedEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
        lMyAgentId = getMyAgentIdsByOrganization(gUserDetails.UserId, [lSelectedEnrollee.OrganizationId]);

    return lMyAgentId;
}

function generateSoberTrackOffenderPhoto(aParams) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('EnrolleeId', aParams.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('PhotoTypeId', 4, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.OffenderPhotos.AssemblyQualifiedName, lBuilder.RootExpression, 0, generateSoberTrackOffenderPhoto_OnSuccess, null, aParams, null, 0);


}

function generateSoberTrackOffenderPhoto_OnSuccess(aParams, aData) {
    'use strict';
    var lSort = new SortExpression();
    lSort.addDescendingColumn('PhotoOrderNo');

    if (!aData.hasOwnProperty("Data") && aData.length != 0) {
        mEnrolleesData.OffenderPhotosAlcohol = lSort.sort(aData);
        mEnrolleesData.OffenderPhotoIndexAlcohol = 0;
        $("#uOffenderSoberTrackProfilePhoto").attr("src",  MUGSHOTS + mEnrolleesData.OffenderPhotosAlcohol[0].PhotoUri);
        $("#uOffenderSoberTrackProfilePhoto").attr("title", mEnrolleesData.OffenderPhotosAlcohol[0].PhotoDescription);
        $("#uOffenderSoberTrackProfilePhoto").css("width", "auto");
        $("#uPreviousOffenderSoberTrackPhotoButton").hide();
        if (aData.length == 1) {
            $("#uPreviousOffenderSoberTrackPhotoButtonContainer").hide();
            $("#uNextOffenderSoberTrackPhotoButton").hide();
            $("#uNextOffenderSoberTrackPhotoButtonContainer").hide();
        } else {
            $("#uPreviousOffenderSoberTrackPhotoButtonContainer").show();
        }

        $("#uSoberTrackPhotoNumberContainer").show();

        //if (mEnrolleesData.OffenderPhotosAlcohol[0].PhotoTypeId == 4) {
         //   $("#uOffenderSoberTrackProfilePhoto").addClass('AlcoholUploadedImage');
       // } else {
       //     $("#uOffenderSoberTrackProfilePhoto").removeClass('AlcoholUploadedImage');
       // }
        updateSoberTrackPhotoNumbers();

    } else {
        mEnrolleesData.OffenderPhotosAlcohol = [];
        $('#uOffenderSoberTrackProfilePhoto').attr('src', 'Images/NoPhoto.png');
        $("#uOffenderSoberTrackProfilePhoto").css("width", "97px");
        $("#uOffenderSoberTrackProfilePhoto").attr("title", "Enrollee Photo");
        $("#uPreviousOffenderSoberTrackPhotoButton").hide();
        $("#uPreviousOffenderSoberTrackPhotoButtonContainer").hide();
        $("#uNextOffenderSoberTrackPhotoButton").hide();
        $("#uNextOffenderSoberTrackPhotoButtonContainer").hide();
        $("#uSoberTrackPhotoNumberContainer").hide();
    }

    if (aData.length > 1) {
        $("#uNextOffenderSoberTrackPhotoButton").show();
        $("#uNextOffenderSoberTrackPhotoButtonContainer").hide();
    }


}

function updateSoberTrackPhotoNumbers() {
    "use strict";
    var lCurrentIndex = mEnrolleesData.OffenderPhotoIndexAlcohol + 1;
    $("#uSoberTrackPhotoNumberContainer").show();
    $("#uSoberTrackPhotoNumberContainer").html(lCurrentIndex + " of " + mEnrolleesData.OffenderPhotosAlcohol.length);
}

function uGoToNextOffenderSoberTrackPhoto(aDirection) {
    "use strict";
    var lNextOffender,
        lCurrentOffender,
        lFoundOffender = false;


    if (mEnrolleesData.OffenderPhotoDescriptionAlcohol != mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].PhotoDescription && mEnrolleesData.OffenderPhotoDescriptionAlcohol != '') {

        lCurrentOffender = new OffenderPhoto();
        lCurrentOffender.Id = mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].Id;
        lCurrentOffender.EnrolleeId = mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].EnrolleeId;
        lCurrentOffender.PhotoUri = null;
        lCurrentOffender.PhotoOrderNo = mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].PhotoOrderNo;
        lCurrentOffender.IsActive = mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].IsActive;
        lCurrentOffender.PhotoDescription = mEnrolleesData.OffenderPhotoDescriptionAlcohol;

        if (mEnrolleesData.OffenderPhotosEditedAlcohol.length == 0) {
            mEnrolleesData.OffenderPhotosEditedAlcohol.push(lCurrentOffender);
        } else {
            for (var i = 0; i < mEnrolleesData.OffenderPhotosEditedAlcohol.length; i++) {
                if (mEnrolleesData.OffenderPhotosEditedAlcohol[i].Id == lCurrentOffender.Id && mEnrolleesData.OffenderPhotosEditedAlcohol[i].PhotoUri == null) {
                    mEnrolleesData.OffenderPhotosEditedAlcohol[i] = lCurrentOffender;
                    lFoundOffender = true;
                    break;
                }//end of if
            }//end of for

            if (!lFoundOffender) {
                mEnrolleesData.OffenderPhotosEditedAlcohol.push(lCurrentOffender);
            }
        }//end of else

        mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].PhotoDescription = mEnrolleesData.OffenderPhotoDescriptionAlcohol;
    }//end of outer if

    if (aDirection == 1 && mEnrolleesData.OffenderPhotoIndexAlcohol == mEnrolleesData.OffenderPhotosAlcohol.length - 2) {
        mEnrolleesData.OffenderPhotoIndexAlcohol++;
        lNextOffender = mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol];
        $("#uOffenderSoberTrackProfilePhoto").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
        $("#uOffenderSoberTrackProfilePhoto").attr("title", lNextOffender.PhotoDescription);
        $("#uNextOffenderSoberTrackPhotoButton").hide();
        $("#uNextOffenderSoberTrackPhotoButtonContainer").show();
        $("#uPreviousOffenderSoberTrackPhotoButton").show();
        $("#uPreviousOffenderSoberTrackPhotoButtonContainer").hide();
    } else if (aDirection == -1 && mEnrolleesData.OffenderPhotoIndexAlcohol == 1) {
        mEnrolleesData.OffenderPhotoIndexAlcohol--;
        lNextOffender = mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol];
        $("#uOffenderSoberTrackProfilePhoto").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
        $("#uOffenderSoberTrackProfilePhoto").attr("title", lNextOffender.PhotoDescription);
        $("#uPreviousOffenderSoberTrackPhotoButton").hide();
        $("#uPreviousOffenderSoberTrackPhotoButtonContainer").show();
        $("#uNextOffenderSoberTrackPhotoButton").show();
        $("#uNextOffenderSoberTrackPhotoButtonContainer").hide();
    } else {
        mEnrolleesData.OffenderPhotoIndexAlcohol = mEnrolleesData.OffenderPhotoIndexAlcohol + aDirection;
        lNextOffender = mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol];
        $("#uOffenderSoberTrackProfilePhoto").attr("src",  MUGSHOTS + lNextOffender.PhotoUri);
        $("#uOffenderSoberTrackProfilePhoto").attr("title", lNextOffender.PhotoDescription);
        $("#uPreviousOffenderSoberTrackPhotoButton").show();
        $("#uPreviousOffenderSoberTrackPhotoButtonContainer").hide();
        $("#uNextOffenderSoberTrackPhotoButton").show();
        $("#uNextOffenderSoberTrackPhotoButtonContainer").hide();
    }

    //if (mEnrolleesData.OffenderPhotosEditMode == "Edit") {
    //   uCancelOffenderPhotoButton_OnClick();
    //}

    mEnrolleesData.OffenderPhotoDescriptionAlcohol = mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].PhotoDescription;
    //$("#uPhotoType").val(mEnrolleesData.OffenderPhotos[mEnrolleesData.OffenderPhotoIndex].PhotoTypeId);

    if (isNullOrUndefined(mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].PhotoUri) || mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].PhotoUri == "") {
        $("#uOffenderSoberTrackProfilePhoto").attr("src", "Images/NoPhoto.png");
    }

    //if (mEnrolleesData.OffenderPhotosAlcohol[mEnrolleesData.OffenderPhotoIndexAlcohol].PhotoTypeId == 4) {
    //    $("#uOffenderSoberTrackProfilePhoto").addClass('AlcoholUploadedImage');
   // } else {
   //     $("#uOffenderSoberTrackProfilePhoto").removeClass('AlcoholUploadedImage');
   // }

    updateSoberTrackPhotoNumbers();

}

function showSobertTrackTestResults() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lStartDate = new Date(moment(mEnrolleesData.CurrentAlcoholSchedule.StartDate).format("dddd MMM D hh:mm a YYYY")),
        lStopDate = new Date(moment(mEnrolleesData.CurrentAlcoholSchedule.StopDate).format("dddd MMM D hh:mm a YYYY")),
        lColumns = [],
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lNumRetestMax = checkOrganizationProperty(lEnrollee.OrganizationId, "alcohol_number_of_retests"),
        lHideBAC = veritracks.core.GetOriProperty(lEnrollee.OrganizationId, 'hide_bac_level');

    lNumRetestMax++;
    $('.NotesButton').hide();
    $("#uSoberTrackReviewContentHolder").hide();
    $("#uSoberTrackTestResultContentHolder").show();
    $('.SummaryButton').removeClass('ConsumerPreviewDisabled');
    $('.NextButton').addClass('ConsumerPreviewDisabled');
    $('.PreviousButton').addClass('ConsumerPreviewDisabled');
    $('.ConfirmButton').hide();
    $('.ResultsButton').hide();

    lColumns['StartDate'] = { 'dataType': 'date', 'formatMethod': DisplayShortDateTimeAgentTimeZone };
    lColumns['StopDate'] = { 'dataType': 'date', 'formatMethod': DisplayShortDateTimeAgentTimeZone };
    lColumns['Bac'] = {  'formatMethod': function(aParameter,aTest){
        return lHideBAC && [0,2].indexOf(aTest.StatusId) > -1? '--':aParameter;
    } };

    $('#uSoberTrackTestResultContentHolderLoadingBar').show();
    if (mEnrolleesData.CurrentAlcoholSchedule.StatusId != 0) {
        mEnrolleesControls.SoberTrackTestResultControl = new VeritracksSoberTrackResultControl("CorrelateControl", "uSoberTrackTestResultContentHolder", { 'Columns': lColumns, 'CardDisplayLimit': lNumRetestMax }, "Interface/SoberTrack.TestResult.Popup.htm", null, null);
    } else {
        mEnrolleesControls.SoberTrackTestResultControl = new VeritracksSoberTrackResultControl("CorrelateControl", "uSoberTrackTestResultContentHolder", { 'Columns': lColumns}, "Interface/SoberTrack.TestResult.Popup.htm", null, null);
    }


    lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lBuilder.AddNewExpressionConditional('ScheduleId', mEnrolleesData.CurrentAlcoholSchedule.ScheduleId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lBuilder.AddNewExpressionConditional('ScheduleType', mEnrolleesData.CurrentAlcoholSchedule.ScheduleType, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    //if (mEnrolleesData.CurrentAlcoholSchedule.ScheduleType != 401) {
        lBuilder.AddNewExpressionConditional('StartDate', lStartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
    //}

        ReadMultiple(gObjectList.OffenderAlcoholTestResult.AssemblyQualifiedName, lBuilder.RootExpression, 0, generateSoberTrackOffenderTestResults_OnSuccess, generateSoberTrackOffenderTestResults_OnFailure, lStartDate, null, 0);

}

function getAlcoholTestResults() {
    "use strict";

}

function generateSoberTrackOffenderTestResults_OnFailure(a, b, c) {
    //console.log(a, b, c);
}

function generateSoberTrackOffenderTestResults_OnSuccess(aParams, aData) {
    "use strict";
    var lImageIds = [],
        lNewestDate = new Date(),
        lTempDate = null,
        lStartDate = aParams,
        lData = [],
        lBuilder = new SumoPredicateBuilder();

    if (aData.length) {
        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {             
                lImageIds.push(aData[key].ImageId);
                aData[key]["BacLimit"] = aData[key].BacLimit / 100;
                aData[key]["Bac"] = aData[key].Bac / 1000;
                lData.push(aData[key]);
                lTempDate = new Date(fixDate(aData[key]["StartDate"]));
                if (lTempDate < lNewestDate) {
                    lNewestDate = lTempDate;
                }
            }
        }
        

        lBuilder.AddNewExpressionConditional('ImageId', lImageIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if (!isNullOrUndefined(lTempDate)) {
            lNewestDate = moment(lNewestDate);
            lBuilder.AddNewExpressionConditional('StartDate', lNewestDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        }
        ReadMultiple(gObjectList.OffenderAlcoholImage.AssemblyQualifiedName, lBuilder.RootExpression, 0, generateSoberTrackOffenderTestResultsImage_OnSuccess, generateSoberTrackOffenderTestResultsImage_OnFailure, lData, null, 0);
    }

}

function generateSoberTrackOffenderTestResultsImage_OnFailure(a, b, c) {
   // console.log(a, b, c);
}

function generateSoberTrackOffenderTestResultsImage_OnSuccess(aParams, aData) {
    "use strict";
    var lTestImage = null,
        lPreFix = veritracks.system.clientSetting("alcoholimagefolder"),
        lDisCount = 0,
        lDisData = [],       
        lData = [];

    lDisCount = aParams.length - aData.length;

    for (var i = 0; i < lDisCount; i++) {
        lDisData.push({ "ImageId": 0, "DeviceImageUrl": "Images/NoPhoto.png" });
    }

    aData = aData.concat(lDisData);

    
    for (var key in aParams) {
        if (aParams.hasOwnProperty(key)) {
            lTestImage = aParams[key];
            for (var item in aData) {
                if (aData.hasOwnProperty(item)) {                    
                    if (lTestImage.ImageId == aData[item].ImageId && lTestImage.ImageId != 0 && (aData.DeviceImageUrl != null || aData.DeviceImageUrl != '')) {
                        lTestImage.DeviceImageUrl = lPreFix + aData[item].DeviceImageUrl;
                        lTestImage.DeviceVideoUrl = aData[item].DeviceVideoUrl;
                        lTestImage.VideoRequestedDate = aData[item].VideoRequestedDate;
                        lTestImage.VideoRequestedDateUTC = aData[item].VideoRequestedDateUTC;
                        lTestImage.VideoRequestedUserId = aData[item].VideoRequestedUserId;
                        break;
                    } else {

                        if (aParams[key].StatusId != 2 && aParams[key].StatusId != 3 && aParams[key].StatusId != 4) {
                            lTestImage.DeviceImageUrl = "Images/PendingPhoto.png";
                        } else {
                            lTestImage.DeviceImageUrl = "Images/NoPhoto.png";
                        }
                    }
                }
            }//end of for

            lData.push(lTestImage);
        }//end of if
    }//end of for
    FixDates(lData);

    $('#uSoberTrackTestResultContentHolderLoadingBar').hide();

    $('.SobertrackRetrieveVideoButton').removeClass('Disabled');

    if (lData.length > 0) {        
        if (lData[0].DeviceImageUrl == 'Images/NoPhoto.png') {
            $('.SobertrackDownloadVideoButton').addClass('ConsumerPreviewDisabled');
            $('.SobertrackRetrieveVideoButton').addClass('ConsumerPreviewDisabled');
        }
        else if (!isNullOrUndefined(lData[0].DeviceVideoUrl)) {
            $('.SobertrackDownloadVideoButton').removeClass('ConsumerPreviewDisabled');
            $('.SobertrackRetrieveVideoButton').addClass('ConsumerPreviewDisabled');

        } else {
            if (!isNullOrUndefined(mEnrolleesData.CurrentAlcoholImage) && (lData[0].VideoRequestedUserId == null || lData[0].VideoRequestedUserId == -1)) {
                $('.SobertrackDownloadVideoButton').addClass('ConsumerPreviewDisabled');
                $('.SobertrackRetrieveVideoButton').removeClass('ConsumerPreviewDisabled');
            } else {

                var minuteDifference = moment.duration(moment().diff(moment(lData[0].VideoRequestedDateUTC))).asMinutes()

                if (minuteDifference > 15) {
                    $('.SobertrackDownloadVideoButton').addClass('ConsumerPreviewDisabled');
                    $('.SobertrackRetrieveVideoButton').removeClass('ConsumerPreviewDisabled');
                } else {
                    $('.SobertrackDownloadVideoButton').addClass('ConsumerPreviewDisabled');
                    // video request has been sent.
                    $('.SobertrackRetrieveVideoButton').removeClass('ConsumerPreviewDisabled');
                    $('.SobertrackRetrieveVideoButton').addClass('Disabled');
                }                
            }
        }
    }

    if (!isNullOrUndefined(lData[0].DeviceVideoUrl) && lData[0].DeviceVideoUrl != '') {
        $('.SobertrackDownloadVideoButton').removeClass('ConsumerPreviewDisabled');
        $('.SobertrackRetrieveVideoButton').addClass('ConsumerPreviewDisabled');
    }

    mEnrolleesData.CurrentAlcoholImages = aData;

    mEnrolleesControls.SoberTrackTestResultControl.setDataSource(lData);
    mEnrolleesData.SoberTrackResultsDirty = lData;
    mEnrolleesData.CurrentAlcoholResult = lData[0];
}


/********************************************/
/********SoberTrack Calendar Creation********/
/********************************************/
function uSoberTrackScheduleButton_OnClick() {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lEnrollee = mEnrolleesControls.CardView.selectedDataItem();
    var lTitle = localizeText('cSoberTrackTitle') + " - " + lEnrollee.FullName + ' (' + lEnrollee.PrimaryId + ')';

    mEnrolleesData.SoberTrackBlockDelete = [];

    if (mEnrolleesData.SoberTrackAssigned) {
        lButtonBar.append(GenerateButton(localizeWrapper('cSoberTrackOnDemandCreate') + "&nbsp;&nbsp;&nbsp;", 'SoberTrackDevice', 'createSoberTrackOnDemand()'));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'saveSoberTrack Save', 'saveSoberTrackScheduleCreated()'));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeDelete'), 'Remove', 'deleteSoberTrackScheduleBlocks()'));
    }

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'ClosePopup()'));

    DisplayPopup(lTitle, '<div id="uSoberTrackSchedulePopupHolder"></div>', lButtonBar, false);
    populateElement('uSoberTrackSchedulePopupHolder', 'SoberTrack.Schedules.Popup.htm', uSoberTrackOnDemandStatus);
}
function uSoberTrackScheduleButtonInModal_OnClick(){
    uSoberTrackScheduleButton_OnClick();
    ClosePopup();
}

function uSoberTrackOnDemandStatus() {
    "use strict";
    getSoberTrackOnDemandIsReady(mEnrolleesData.OffenderCurrentId, $('.SoberTrackDeviceButton'));
    uSoberTrackSchedulePopulate_Init();
}

function uSoberTrackSchedulePopulate_Init() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.OffenderAlcoholSchedBlock.AssemblyQualifiedName, lBuilder.RootExpression, 0, populateCorrectScheduleView_onSuccess, populateCorrectScheduleView_onFail, mEnrolleesData.OffenderCurrentId, null, 0, true);
}

function populateCorrectScheduleView_onSuccess(aParams, aData) {
    "use strict";
    var lDefaultTab,
        lFilename,
        lFunction;

    if (mEnrolleesData.SoberTrackAssigned) {
        if (aData.length >= 1) {
            lDefaultTab = 'Live';
        } else {
            lDefaultTab = 'Design';
        }
    } else {
        lDefaultTab = 'Live';
    }

    lFilename = 'SoberTrack.Schedules.' + lDefaultTab + '.htm';
    lFunction = window['populateSoberTrack' + lDefaultTab + 'Schedule'];

    $('#uSoberTrackScheduleMenuPanel .Selected').removeClass('Selected');
    $('#uSoberTrackScheduleMenuPanel .' + lDefaultTab + 'Tab').addClass('Selected');

    populateElement('uSoberTrackScheduleContentPanel', lFilename, lFunction);
}

function populateCorrectScheduleView_onFail(a, b, c, d) {
    "use strict";
}


function SoberTrackSchedulePanelOnChange(aTab, aDetails) {
    "use strict";
    var lFilename = 'SoberTrack.Schedules.' + aTab + '.htm';
    var lMethodName = window['populateSoberTrack' + aTab + 'Schedule'];

    $('#uSoberTrackScheduleMenuPanel .Selected').removeClass('Selected');
    $('#uSoberTrackScheduleMenuPanel .' + aTab + 'Tab').addClass('Selected');

    mEnrolleesData.SchedulePopupOption = aTab;
    populateElement('uSoberTrackScheduleContentPanel', lFilename, lMethodName);
}

function populateSoberTrackLiveSchedule() {
    "use strict";
    var soberTrackDesign = $('<div id="uSoberTrackLiveChart" style="width:100%;"><div class="loadingGif FixedCenteredDisplay"></div></div>'),
    soberTrackDesignHolder = $('#uSoberTrackScheduleLiveViewHolder');

    soberTrackDesignHolder.append(soberTrackDesign);

    if (mEnrolleesData.SoberTrackAssignedPreviously) {
        $('#uSoberTrackScheduleMenuDesign').hide();
    }

    $('.PopupWindow').removeClass('CalendarWidthSoberTrack');
    $('.PopupWindow').addClass('CalendarWidthSoberTrackLive');
    $('.PopupWindow .SaveButton').hide();
    SoberTrackLiveChart();
}

function populateSoberTrackDesignSchedule() {
    "use strict";
    var soberTrackDesign = $('<div id="uSoberTrackDesignChart" style="width:100%;"><div class="loadingGif FixedCenteredDisplay"></div></div>'),
        soberTrackDesignHolder = $('#uSoberTrackScheduleDesignViewHolder');

    soberTrackDesignHolder.append(soberTrackDesign);

    $('.PopupWindow').removeClass('CalendarWidthSoberTrackLive');
    $('.PopupWindow').addClass('CalendarWidthSoberTrack');
    scheduleDesignRules_ControlInit();
    $('.PopupWindow .SaveButton').show();
    SoberTrackDesignChart();
    removeDatesOnDesignCalendar();
}

function removeDatesOnDesignCalendar() {
    "use strict";
    $('.fc-day-header.fc-sun').html(localizeText('cSunday'));
    $('.fc-day-header.fc-mon').html(localizeText('cMonday'));
    $('.fc-day-header.fc-tue').html(localizeText('cTuesday'));
    $('.fc-day-header.fc-wed').html(localizeText('cWednesday'));
    $('.fc-day-header.fc-thu').html(localizeText('cThursday'));
    $('.fc-day-header.fc-fri').html(localizeText('cFriday'));
    $('.fc-day-header.fc-sat').html(localizeText('cSaturday'));
    $('.fc-toolbar').remove();
}
/********************************************/
/****SoberTrack Live Schedule Events Data****/
/********************************************/
function SoberTrackLiveChart(aRefresh) {
    "use strict";

    $('#uPopupPanel').addClass('LowZIndex');

    mEnrolleesControls.sobertracksLiveChart = new VeritracksFullCalendarWrapper('#uSoberTrackLiveChart',
    {
        "defaultView": "agendaWeek",
        "slotEventOverlap": true,
        "selectOverlap": true,
        "multiDaySelect": true,
        "displayEventEnd": true,
        "editable": true,
        "eventDurationEditable": false,
        "aspectRatio": 1.64,
        "selectable": false,
        "pastSelectable": false,
        "selectHelper": true,
        "selectMultiDay": false,
        "allDaySlot": false,
        "rightClickOptions": 'agendaWeek',
        "lazyFetching": true,
        "leftClickOptions": 'prev,next, today'
    },
    {
        "viewRender": viewRender_SoberTracksLiveChart,
        "clickHandler": clickHandler_SoberTracksLiveChart,
        "events": events_SoberTracksLiveChart,
        "afterRender": afterRender_SoberTracksLiveChart
    });

    $('.PopupWindow').removeClass('CalendarWidthSoberTrack');
    $('.PopupWindow').addClass('CalendarWidthSoberTrackLive');

    mEnrolleesControls.sobertracksLiveChart.setView('agendaDay');
    mEnrolleesControls.sobertracksLiveChart.setView('agendaWeek');


    $('.CalendarWidthSoberTrackLive .RemoveButton').hide();
    $('.fc-today-button').hide();
    $('.fc-agendaWeek-button').hide();

    $('.loadingGif').hide();
}

function clickHandler_SoberTracksLiveChart(aEvent, deleteOnly) {
    "use strict";
    var lCopy = $.extend({}, aEvent);
    var lScheduleType = aEvent.ScheduleType;
    if (lScheduleType == 201 || lScheduleType == 301 || lScheduleType == 401) {
        uQuickReviewAlcoholMonitoring(aEvent, mStateManager.Hash());
    }
}

function afterRender_SoberTracksLiveChart(event, elt) {
    "use strict";
    var lDefaultMy = 'left top';
    var lDefaultAt = 'right top';

    if (event.ScheduleType == 101 || event.ScheduleType == 501) {
         elt.find("div.fc-content").prepend(soberTrackConfirmFlagMapIconFormatter(event.ConfirmFlag));
         elt.addClass('uLiveSchedBlock');
    } else {
        elt.addClass('uLiveSchedTest');
        elt.find('.fc-event-time').remove();
        elt.find('.fc-title').remove();
        elt.find("div.fc-content").prepend(soberTrackLiveStatusIconEvent(event));
        var statusIcon = EnrolleesSoberTrackTestStatusFormatter(event.StatusName,event);
        elt.qtip({
            content: {
                text: event.ScheduleTypeName + " Test   " +statusIcon
            },
            hide: { when: { event: 'unfocus' } },
            position: {
                my: lDefaultMy,
                at: lDefaultAt,
                adjust: {
                    method: 'shift'
                },
                viewport: $(window)
            },
            show: {
                delay: 100
            },
            style: 'qtip-bootstrap qtip-no-width'
        });
    }
}

function liveChartTestStatus(aEvent) {
    "use strict";
    var lStatusId = aEvent.StatusId,
        lEnrollee = getDataItem(aEvent.EnrolleeId, 'Enrollees'),
        lInProgress = false;

    if (!isNullOrUndefined(lEnrollee)) {
        var lMaxReTest = checkOrganizationProperty(lEnrollee.OrganizationId, "alcohol_number_of_retests");
        lMaxReTest++;
        if (!isNullOrUndefined(aEvent.MaxNumberRetest)) {
            lMaxReTest = aEvent.MaxNumberRetest;
        }
        //lInProgress = lMaxReTest !== aEvent.NumberRetest ? true : false;
        lInProgress = sobertrackInProgressTestFormatter(aEvent, lMaxReTest);
    }
   
    if (!isNullOrUndefined(lStatusId) && lStatusId == 0) {
        return 'p' + liveChartTestWithImageStatus(aEvent.ImageMatchedFlag);
    } else {
        if (!isNullOrUndefined(lInProgress) && lInProgress == true) {
            return 'i';
        }
        if (lStatusId == 2 || lStatusId == 3) {
            return 'u';
        }
        return 'f' + liveChartTestWithImageStatus(aEvent.ImageMatchedFlag);
    }

}

function liveMapTestStatus(aEvent) {
    "use strict";
    var lStatusId = aEvent.StatusId,
        lEnrollee = getDataItem(aEvent.EnrolleeId, 'Enrollees'),
        lInProgress = false;


    if (!isNullOrUndefined(lEnrollee)) {
        var lMaxReTest = checkOrganizationProperty(lEnrollee.OrganizationId, "alcohol_number_of_retests");
        lMaxReTest++;
        if (!isNullOrUndefined(aEvent.MaxNumberRetest)) {
            lMaxReTest = aEvent.MaxNumberRetest;
        }
        //lInProgress = lMaxReTest !== aEvent.NumberRetest ? true : false;
        lInProgress = sobertrackInProgressTestFormatter(aEvent, lMaxReTest);
    } 

    
    if (isNullOrUndefined(aEvent.ImageData)) {
        if (!isNullOrUndefined(lStatusId) && lStatusId == 0) {
            return [liveMapTestClassStatus(lStatusId, null, lInProgress), mSoberTrackLiveTestResultMapping['p' + liveChartTestWithImageStatus(null)] + '.png'];
        } else {
            if (!isNullOrUndefined(lInProgress) && lInProgress == true) {
                return [liveMapTestClassStatus(lStatusId, null, lInProgress), mSoberTrackLiveTestResultMapping['i'] + '.png'];
            }
            if (!isNullOrUndefined(lStatusId) && (lStatusId == 2 || lStatusId == 3)){
                return [liveMapTestClassStatus(lStatusId, null, lInProgress), mSoberTrackLiveTestResultMapping['u'] + '.png'];
            }
            return [liveMapTestClassStatus(lStatusId, null, lInProgress), mSoberTrackLiveTestResultMapping['f' + liveChartTestWithImageStatus(null)] + '.png'];
        }
    }

    if (!isNullOrUndefined(lStatusId) && lStatusId == 0) {
        return [liveMapTestClassStatus(lStatusId, aEvent.ImageData.ImageMatchedFlag, lInProgress), mSoberTrackLiveTestResultMapping['p' + liveChartTestWithImageStatus(aEvent.ImageData.ImageMatchedFlag)] + '.png'];
    } else {
        if (!isNullOrUndefined(lInProgress) && lInProgress == true) {
            return [liveMapTestClassStatus(lStatusId, null, lInProgress), mSoberTrackLiveTestResultMapping['i'] + '.png'];
        }
        if (!isNullOrUndefined(lStatusId) && (lStatusId == 2 || lStatusId == 3)) {
            return [liveMapTestClassStatus(lStatusId, null, lInProgress), mSoberTrackLiveTestResultMapping['u'] + '.png'];
        }
        return [liveMapTestClassStatus(lStatusId, aEvent.ImageData.ImageMatchedFlag, lInProgress), mSoberTrackLiveTestResultMapping['f' + liveChartTestWithImageStatus(aEvent.ImageData.ImageMatchedFlag)] + '.png'];
    }

}

function liveMapTestClassStatus(aStatusId, aImageMatchedFlag, aInProgress) {
    "use strict";
   
    if (aStatusId == 0) {
        if (isNullOrUndefined(aImageMatchedFlag)) {
            return 'TrackAlcoholPassed';
        } else if (aImageMatchedFlag) {
            return 'TrackAlcoholPassedlValidated';
        } else {
            return 'TrackAlcoholPassedFail';
        }
    } else {
        if (!isNullOrUndefined(aInProgress) && aInProgress === true) {
            return 'TrackAlcoholInProgress';
        } else if (aStatusId == 2 || aStatusId == 3) {
            return 'TrackAlcoholMissed';
        } else if (isNullOrUndefined(aImageMatchedFlag)) {
            return 'TrackAlcoholFail';
        } else if (aImageMatchedFlag) {
            return 'TrackAlcoholFailValidated';
        } else {
            return 'TrackAlcoholFailFail';
        }
    }
}

function liveChartTestWithImageStatus(imageMatchedFlag) {
    "use strict";
    if (imageMatchedFlag === 1) {
        return 'm';
    } else if (imageMatchedFlag === -1 || isNullOrUndefined(imageMatchedFlag)) {
        return 'u';
    } else {
        return 'i';
    }
}


function soberTrackLiveStatusIconEvent(aEvent) {
    var lHtml = [],
        lTestStatus = liveChartTestStatus(aEvent);    

    lHtml.push("<img class='confirmSoberTrackIconPosition uLiveSchedIconsSvg' src='" + mSoberTrackLiveTestResultCharting[lTestStatus] + '.png' + "' width='32px' height='32px'>");

    return lHtml.join('');
}

function soberTrackConfirmFlagMapIconFormatter(aConfirm) {
    var lHtml = [],
        lConfirm = aConfirm;

    lHtml.push("<img class='confirmSoberTrackIconPosition' src='" + mSoberTrackLiveBlockCharting[aConfirm] + '.png' + "' width='16' height='16'>");

    return lHtml.join('');
}

function viewRender_SoberTracksLiveChart() {
    "use strict";
    var aId = mEnrolleesControls.sobertracksLiveChart.calendarId();
    $(aId).fullCalendar('removeEvents');
    $(aId).fullCalendar('addEventSource', mEnrolleesControls.sobertracksLiveChart.getDataSource());
    $(aId).fullCalendar('rerenderEvents');
}

function events_SoberTracksLiveChart(aStartEvent, aEndEvent, aCallback) {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId,
        lStartDate = moment(aStartEvent.format()).add(getOffsetOfSaveDate(), 'minutes'),
        lEndDate = moment(aEndEvent.format()).add(getOffsetOfSaveDate(), 'minutes');

    getSoberTrackLiveEventSchedules(lEnrolleeId, lStartDate, lEndDate, null, function (aOffenderAlcoholSchedules, aOffenderAlcoholPastEvents) {
        if (lEnrolleeId == mEnrolleesData.OffenderCurrentId) {
            mEnrolleesControls.sobertracksLiveChart.setDataSource([]);
            mEnrolleesControls.sobertracksLiveChart.setDataSource(aOffenderAlcoholSchedules);
            if (aCallback) {
                aCallback();
            }
        }
        $('.loadingGif').hide();
    });
}

function getSoberTrackLiveEventSchedules(aEnrolleeId, aStartDate, aEndDate, aParams, aCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lEnrolleeSchedules = [],
        lTimeZone = getEnrolleeTimeZone(aEnrolleeId),
        lKey;

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StartDate', aStartDate._d, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StopDate', aEndDate._d, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.OffenderAlcoholSchedule.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderAlcoholSchedule_OnSuccess, offenderAlcoholSchedule_OnFail, [aStartDate, aEndDate, aParams], null, 0, true);

    function offenderAlcoholSchedule_OnSuccess(aParams, aData) {
        var lBuilder = new SumoPredicateBuilder(),
            lImageIds = [];

        if (aData.length) {
            lImageIds = aData.map(function (data, i) {
                return data.ImageId;
            });

            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('ImageId', lImageIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('StartDate', aStartDate._d, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('StopDate', aEndDate._d, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());

            ReadMultiple(gObjectList.OffenderAlcoholImage.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderAlcoholScheduleImage_OnSuccess, offenderAlcoholScheduleImage_OnFail, aData, null, 0, true);
        } else {
            offenderAlcoholScheduleImage_OnSuccess(aData, []);
        }

        function offenderAlcoholScheduleImage_OnSuccess(aData, aImageData) {
            FixDates(aData);
            var lOffenderAlcoholSchedulesDisplay = [];
            var lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId),
                lCurrentWeek = false,
                lFutureWeek = false,
                lPastWeek = false;

            function findByAlcoholImageId(id, enrolleeId) {
                return aImageData.filter(function (img, i) {
                    if (id == img.ImageId && enrolleeId == img.EnrolleeId) {
                        return img;
                    }
                });
            }

            for (var i = 0; i < aData.length; i++) {
                var lImageInfo = findByAlcoholImageId(aData[i].ImageId, aData[i].EnrolleeId);
                var lOffenderAlcoholSchedule = new displayOffenderAlcoholSchedule(aData[i], lTimeZone, lImageInfo);
                lOffenderAlcoholSchedule.durationEditable = false;
                if (lOffenderAlcoholSchedule.ScheduleType == 201 || lOffenderAlcoholSchedule.ScheduleType == 301 || lOffenderAlcoholSchedule.ScheduleType == 401) {
                    lOffenderAlcoholSchedulesDisplay.push(lOffenderAlcoholSchedule);
                }

            }

            if (mEnrolleesData.SoberTrackAssigned) {
                var lBuilder = new SumoPredicateBuilder();

                lPastWeek = checkIfItIsPastWeek(aStartDate._d, aEndDate._d);
                lCurrentWeek = checkIfItIsCurrentWeek(aStartDate._d, aEndDate._d);
                lFutureWeek = checkIfItIsFutureWeek(aStartDate._d, aEndDate._d);

                lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

                if (lPastWeek) {
                    lBuilder.AddNewExpressionConditional('StartDate', aEndDate._d, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('StopDate', aStartDate._d, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
                }

                if (lCurrentWeek) {
                    lBuilder.AddNewExpressionConditional('StartDate', aEndDate._d, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
                    //need to check if it's also created in same week
                }

                if (lFutureWeek) {
                    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                }

                ReadMultiple(gObjectList.OffenderAlcoholSchedBlock.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderAlcoholSchedBlockOnLive_OnSuccess, offenderAlcoholSchedBlockOnLive_OnFail, [], null, 0, true);
            } else {
                if (aCallback) {
                    aCallback(lOffenderAlcoholSchedulesDisplay);
                }
            }

            function offenderAlcoholSchedBlockOnLive_OnSuccess(_aParams, aData) {
                "use strict";
                var viewEvents = $('#uSoberTrackLiveChart').fullCalendar('getView');
                for (var i = 0; i < aData.length; i++) {
                    if (aData[i].ScheduleType == 101 || aData[i].ScheduleType == 501) {
                        var lOffenderAlcoholSchedBlock = new displayOffenderAlcoholSchedLiveBlock(aData[i], lTimeZone, viewEvents.start, viewEvents.end);
                        lOffenderAlcoholSchedBlock.durationEditable = false;
                        lOffenderAlcoholSchedBlock.startEditable = false;  
                        if (!lOffenderAlcoholSchedBlock.CreatedDateAfterDay && !lOffenderAlcoholSchedBlock.IsActiveMatters && !lOffenderAlcoholSchedBlock.DeletedDateBeforeDay) {
                            lOffenderAlcoholSchedulesDisplay.push(lOffenderAlcoholSchedBlock);
                        }
                    }
                }

                if (aCallback) {
                    aCallback(lOffenderAlcoholSchedulesDisplay);
                }
            }

            function offenderAlcoholSchedBlockOnLive_OnFail() {
                "use strict";
            }

        }

        function offenderAlcoholScheduleImage_OnFail(a, b, c) {
           // console.log(a, b, c);
        }

    }

    function offenderAlcoholSchedule_OnFail() {

    }
}

function checkIfItIsPastWeek(aStart, aEnd) {
    var lStart = aStart,
        lEnd = aEnd,
        lNowMoment = moment(),
        lNow = lNowMoment._d;

    if (lEnd < lNow) {
        return true;
    } else {
        return false;
    }

}

function checkIfItIsCurrentWeek(aStart, aEnd) {
    "use strict";
    var lStart = aStart,
        lEnd = aEnd,
        lNowMoment = moment(),
        lNow = lNowMoment._d;

    if (lStart < lNow) {
        if (lEnd > lNow) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

function checkIfItIsFutureWeek(aStart, aEnd) {
    var lStart = aStart,
        lEnd = aEnd,
        lNowMoment = moment(),
        lNow = lNowMoment._d;

    if (lStart > lNow) {
        return true;
    } else {
        return false;
    }

}

/******************************************/
/*****SoberTrack OnDemand Create Event*****/
/******************************************/
function createSoberTrackOnDemand(aId, aEnrolleeId, aOrganizationId) {
    "use strict";
    var lStartDate = moment(),
        lStartDateClone = lStartDate.clone(),
        lNewEndTime = lStartDateClone.add(30, 'minutes'),
        lButtonBar = GenerateButtonCommandBar();   
    
    if (mEnrolleesData.OffenderAlcoholSchedSTDWarning) {
        lookForCompleteTestOnDemand(aId, aEnrolleeId, aOrganizationId);               
    } else if (mEnrolleesData.OffenderAlcoholSchedSTDPreWarning) {
        lButtonBar.append(GenerateButton(localizeWrapper('cOk'), 'Ok', 'startCreateSoberTrackOnDemand(' + aId + ',' + aEnrolleeId + ',' + aOrganizationId + ',true)'));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Close', 'ClosePopup()'));
        DisplayPopup('Warning', '<div id="uSoberTrackDemandWarningHolder">Warning: There is an upcoming SoberTrack test scheduled. On Demand test may be affected.  Do you wish to proceed?</div>', lButtonBar, false, true);

    } else {
        getSoberTrackOnDemandIsReady(mEnrolleesData.OffenderCurrentId, null, null, lookForCompleteTestOnDemand);
        //startCreateSoberTrackOnDemand(aId, aEnrolleeId, aOrganizationId);
    }
    
}

function lookForCompleteTestOnDemand(aId, aEnrolleeId, aOrganizationId) {
    "use strict";

    var lBuilder = new SumoPredicateBuilder(),
        lEnrolleeId = mEnrolleesData.OffenderCurrentId,
        lTimeZone = getEnrolleeTimeZone(lEnrolleeId);

    if (isNullOrUndefined(mEnrolleesData.OffenderAlcoholSchedWarningData) || isNullOrUndefined(mEnrolleesData.OffenderAlcoholSchedWarningData)) {
        startCreateSoberTrackOnDemand(aId, aEnrolleeId, aOrganizationId);
    } else {
        var ldMoment = moment(mEnrolleesData.OffenderAlcoholSchedWarningData.StartDateUTCString).add(getOffsetOfSaveDate(), 'minutes');
        var lDateMoment = ldMoment.toDate();

        lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', [201, 301], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('StatusId', 0, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('StartDate', lDateMoment, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        //lBuilder.AddNewExpressionConditional('StopDate', lStopDate._d, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());

        ReadMultiple(gObjectList.OffenderAlcoholSchedule.AssemblyQualifiedName, lBuilder.RootExpression, 0, ShowSTDOverlapWarningCallback, getSoberTrackOnDemandIsReady_OnFail, { "aId": aId, "aEnrolleeId": aEnrolleeId, "aOrganizationId": aOrganizationId }, null, 0, true);

    }
}

function ShowSTDOverlapWarningCallback(aParams, aData) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
  
    if (aData.length == 0) {
        lButtonBar.append(GenerateButton(localizeWrapper('cOk'), 'Ok', 'startCreateSoberTrackOnDemand(' + aParams.aId + ',' + aParams.aEnrolleeId + ',' + aParams.aOrganizationId + ',true)'));
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Close', 'ClosePopup()'));
        DisplayPopup('Warning', '<div id="uSoberTrackDemandWarningHolder">Warning: There may be an existing SoberTrack test currently underway. Initiating the On Demand Test may interfere with this test. Do you wish to proceed?</div>', lButtonBar, false, true);
    } else {
        startCreateSoberTrackOnDemand(aParams.aId,aParams.aEnrolleeId, aParams.aOrganizationId)
    }

}

function startCreateSoberTrackOnDemand(aId, aEnrolleeId, aOrganizationId, isFromWarning) {
    "use strict";
    var lStartDate = moment(),
        lStartDateClone = lStartDate.clone(),
        lNewEndTime = lStartDateClone.add(30, 'minutes'),
        lButtonBar = GenerateButtonCommandBar();

    if (isFromWarning) {
        ClosePopup();
    }
   
    //add disable on demand button
    if (aId == 1) { //dashboard
        var lEnrolleeId = aEnrolleeId,
            lOrganizationId = aOrganizationId,
            lTimeZone = getEnrolleeTimeZone(aEnrolleeId);
    } else {
        var lEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
            lOrganizationId = lEnrollee.OrganizationId,
            lEnrolleeId = mEnrolleesData.OffenderCurrentId,
            lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
    }


    var lNewOnDemandEvent = new OffenderAlcoholSchedBlock();
    lNewOnDemandEvent.StartDate = convertTimeToUTC(lStartDate.toDate(), lTimeZone.TimeZoneName);
    lNewOnDemandEvent.StopDate = convertTimeToUTC(lNewEndTime.toDate(), lTimeZone.TimeZoneName);
    lNewOnDemandEvent.AppUserId = gUserDetails.UserId;
    lNewOnDemandEvent.EnrolleeId = lEnrolleeId;
    lNewOnDemandEvent.EnrolleeTimeZone = lTimeZone.TimeZoneName;
    lNewOnDemandEvent.ScheduleType = 401;
    lNewOnDemandEvent.OrganizationId = lOrganizationId;
    lNewOnDemandEvent.DayOfWeek = '';
    lNewOnDemandEvent.StartHour = '00:00';
    lNewOnDemandEvent.StopHour = '00:00';
    lNewOnDemandEvent.Name = localizeText('cSoberTrackOnDemandTest');
    lNewOnDemandEvent.NumberOfTest = 1;
    lNewOnDemandEvent.MinuteBetweenTest = 60;

    WriteSingle(lNewOnDemandEvent, onCreateNewOnDemand_OnSuccess, onCreateNewOnDemand_OnFailure, [lNewOnDemandEvent, aId], true);
}

function onCreateNewOnDemand_OnSuccess(aParams, aData) {
    "use strict";
    var lParams = aParams[0],
        lId = aParams[1],
        lStart = lParams.StartDate,
        lStop = lParams.StopDate;
    mActivityNotification.addNotification(localizeWrapper('cSoberTrackOnDemandSaved'));

   // $('.SoberTrackDeviceButton').addClass('Disabled');
    setPointerStatusOfOnDemand('none');
}

function onCreateNewOnDemand_OnFailure(a, b, c, d, e) {
    "use strict";
    var lParams = aParams[0],
        lId = aParams[1];

    mActivityNotification.addNotification(localizeWrapper('cSoberTrackOnDemandError'));

    setPointerStatusOfOnDemand('auto');
    aParams.removeClass('Disabled');

}

function getSoberTrackOnDemandIsReady(aEnrolleeId, aButtonId, aCallBack, aDemandCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lEnrollee = getDataItem(aEnrolleeId, 'Enrollees'),
        lTimeZone = getEnrolleeTimeZone(aEnrolleeId),
        lStopDate = convertTimeToUTC(new Date('12/30/9999'), lTimeZone.TimeZoneName);
 
    
    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    //lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ScheduleType', [101, 501], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StopDate', lStopDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
 
    if (!isNullOrUndefined(aDemandCallback)) {
        ReadMultiple(gObjectList.OffenderAlcoholSchedBlock.AssemblyQualifiedName, lBuilder.RootExpression, 0, checkSoberTrackOnDemandIsReady_OnSuccess, getSoberTrackOnDemandIsReady_OnFail, aDemandCallback, null, 0, true);
    } else if (isNullOrUndefined(aCallBack)) {
        ReadMultiple(gObjectList.OffenderAlcoholSchedBlock.AssemblyQualifiedName, lBuilder.RootExpression, 0, getSoberTrackOnDemandIsReady_OnSuccess, getSoberTrackOnDemandIsReady_OnFail, aButtonId, null, 0, true);
    } else {
        ReadMultiple(gObjectList.OffenderAlcoholSchedBlock.AssemblyQualifiedName, lBuilder.RootExpression, 0, getSoberTrackOnDemandIsReady_OnSuccess, getSoberTrackOnDemandIsReady_OnFail, aCallBack, null, 0, true);
    }
}

function checkSoberTrackOnDemandIsReady_OnSuccess(aCallback, aData) {
    "use strict";
    var lEnrollee;
        

    if (aData.length && aData.length > 0) {      
        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                if (soberTrackOnDemandTimeUpOverlap(aData[key])) {
                   
                } else {
                    break;
                }
            }
        }
    }

    //if (mEnrolleesData.OffenderAlcoholSchedSTDWarning || mEnrolleesData.OffenderAlcoholSchedSTDPreWarning) {
    if (!isNullOrUndefined(gDashboardPage) && !isNullOrUndefined(mEnrolleesData.OffenderCurrentId)) {
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
        aCallback(1, lEnrollee.Id, lEnrollee.OrganizationId);
    } else {
        aCallback();        
    }
        
    //}
}

function getSoberTrackOnDemandIsReadyWithCallBack_OnSuccess(aCallBack, aData) {
    if (aData.length) {
        if (soberTrackOnDemandTimeUp(aData[0])) {
            setPointerStatusOfOnDemand('auto');
            $('.SoberTrackDeviceButton').removeClass('Disabled');
            if (typeof aCallBack !== "undefined" && typeof aCallBack === "function") {
                aCallBack(false);
            }
            
        } else {
            setPointerStatusOfOnDemand('none');
            $('.SoberTrackDeviceButton').addClass('Disabled');
            if (typeof aCallBack !== "undefined" && typeof aCallBack === "function") {
                aCallBack(true);
            }           
        }
    } else {
        setPointerStatusOfOnDemand('auto');
        $('.SoberTrackDeviceButton').removeClass('Disabled');
        if (typeof aCallBack !== "undefined" && typeof aCallBack === "function") {
            aCallBack(false);
        }       
    }
}

function getSoberTrackOnDemandIsReady_OnSuccess(aParams, aData) {
    "use strict";
    
    if (aData.length) {
        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                if (soberTrackOnDemandTimeUpOverlap(aData[key])) {
                    setPointerStatusOfOnDemand('auto');
                    if (!isNullOrUndefined(aParams) && typeof aParams !== 'function') {
                        aParams.removeClass('Disabled');
                    }                    
                } else {
                    //aParams.addClass('Disabled');
                    //setPointerStatusOfOnDemand('none');
                    break;
                }
            }
        }
    } else {
        setPointerStatusOfOnDemand('auto');
        if (!isNullOrUndefined(aParams) && typeof aParams !== 'function') {
            aParams.removeClass('Disabled');
        }
    }
}

function setPointerStatusOfOnDemand(status) {
    "use strict";
    var lButtons = document.getElementsByClassName("SoberTrackDeviceButton");

    Array.prototype.map.call(lButtons, function (lButton) {
        lButton.style.pointerEvents = status;
    });
}

function soberTrackOnDemandTimeUp(aData) {
    "use strict";
    var lChecks = checkOrganizationProperty(aData.OrganizationId, "alcohol_number_of_retests") + 1,
       lInterval = checkOrganizationProperty(aData.OrganizationId, "alcohol_interval_of_retest"),
       lTotalTimeUp = lChecks * lInterval,
       lNow = moment(),
       lCompareDate = lNow.add(-lTotalTimeUp, 'minutes'),
       lBlockStartDate = moment(aData.StartDate).add(-getOffsetOfSaveDate(), 'minutes');
       

    if (lCompareDate < lBlockStartDate) {
        return false;
    } else {
        return true;
    }
}

function soberTrackOnDemandTimeUpOverlap(aData) {
    "use strict";
    var lNow = moment(),
       lDayOfWeek = DayOfWeekIntEnum(aData.DayOfWeek),
       lStartMoment = moment().add(-(lNow._d.getDay() - lDayOfWeek), 'days'),
       lSchedStartDay = lStartMoment._d.getDate(),
       lSchedStartMonth = lStartMoment._d.getMonth() + 1,
       lStartMonthString = (lSchedStartMonth.toString().length == 1 ? '0' + lSchedStartMonth : lSchedStartMonth),
       lStartDayString = (lSchedStartDay.toString().length == 1 ? '0' + lSchedStartDay : lSchedStartDay),
       lBlockStartDate = moment(new Date(lNow._d.getFullYear() + '-' + lStartMonthString + '-' + lStartDayString + 'T' + aData.StartHour + ':00')),
       lBlockStopDate = moment(new Date(lNow._d.getFullYear() + '-' + lStartMonthString + '-' + lStartDayString + 'T' + aData.StopHour + ':00')),
       lTimeSinceTest = (lNow._d.getTime() - lBlockStartDate._d.getTime()) / 60000,
       lTimeToPass = (lBlockStopDate._d.getTime() - lBlockStartDate._d.getTime())  / 60000;
        
    if (lTimeSinceTest < lTimeToPass && lTimeSinceTest > 0) {
        mEnrolleesData.OffenderAlcoholSchedSTDWarning = true;
        mEnrolleesData.OffenderAlcoholSchedWarningData = aData;
        mEnrolleesData.OffenderAlcoholSchedWarningData.StartDate = lBlockStartDate._d;
        mEnrolleesData.OffenderAlcoholSchedWarningData.StartDateUTCString = lBlockStartDate._d.toUTCString();
        mEnrolleesData.OffenderAlcoholSchedSTDPreWarning = false;
        return false;
    } else {
        if (lTimeSinceTest <= 0 && lTimeSinceTest >= -30) {
            mEnrolleesData.OffenderAlcoholSchedSTDPreWarning = true;
        }
        mEnrolleesData.OffenderAlcoholSchedSTDWarning = false;
        mEnrolleesData.OffenderAlcoholSchedWarningData = null;
        
        return true;
    }
}


function getSoberTrackOnDemandIsReady_OnFail(a, b, c) {
    "use strict";
    console.log(a);
}


/****************************************/
/*SoberTrack Design Schedule Events Data*/
/****************************************/
function SoberTrackDesignChart(aRefresh) {
    "use strict";

    $('#uPopupPanel').addClass('LowZIndex');

    mEnrolleesControls.sobertracksDesignChart = new VeritracksFullCalendarWrapper('#uSoberTrackDesignChart',
    {
        "defaultView": "agendaWeek",
        "slotEventOverlap": true,
        "selectOverlap": true,
        "multiDaySelect": true,
        "displayEventEnd": true,
        "eventDurationEditable": true,
        "editable": true,
        "aspectRatio": 1.64,
        "selectable": true,
        "pastSelectable": false,
        "selectHelper": false,
        "selectMultiDay": false,
        "allDaySlot": false,
        "lazyFetching": true,
        "rightClickOptions": 'agendaWeek',
        "leftClickOptions": ''
    },
    {
        "specialEventLayout": specialEventLayout_SoberTracksDesignChart,
        "rightClickHandler": rightClickHandler_SoberTracksDesignChart,
        "clickHandler": clickHandlerDelete_SoberTracksDesignChart,
        "selectEventHandler": selectEventHandler_SoberTrackDesignChart,
        "events": events_SoberTracksDesignChart,
        "viewRender": viewRender_SoberTracksDesignChart,
        "eventDragStop": eventDragStop_SoberTracksDesignChart,
        "eventDrop": eventDrop_SoberTracksDesignChart,
        "afterRender": afterRender_SoberTracksDesignChart,
        "eventResize": eventResize_SoberTracksDesignChart
    });

    $('.PopupWindow').removeClass('CalendarWidthSoberTrackLive');
    $('.PopupWindow').addClass('CalendarWidthSoberTrack');
    $('.RemoveButton').show();
    $('.loadingGif').hide();

    mEnrolleesControls.sobertracksDesignChart.setView('agendaDay');
    mEnrolleesControls.sobertracksDesignChart.setView('agendaWeek');
}

function eventResize_SoberTracksDesignChart(aEvent, jsEvent) {
    "use strict";


}

function clickHandlerDelete_SoberTracksDesignChart(aEvent, jsEvent) {
    "use strict";
    //check if already selected for deletion, if it's clicked again it means user probably doesn't wanna delete it anymore
    //so remove class also for right click
    var lCurrentBlock = $(jsEvent.currentTarget);

    if (lCurrentBlock.hasClass('prepareForDeleteSoberTrackBlock')) {
        lCurrentBlock.removeClass("prepareForDeleteSoberTrackBlock");
        deleteFromSoberTrackDeleteArray(aEvent);
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackNotSelectedForDelete'));
    } else {
        lCurrentBlock.addClass("prepareForDeleteSoberTrackBlock");
        mEnrolleesData.SoberTrackBlockDelete.push(aEvent);
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackSelectedForDelete'));
        if (schedulesExistThatHaveNotBeenSaved()) {
            mActivityNotification.addNotification(localizeWrapper('cEnrolleeSchedulesNotSaved'));
        }

    }

}

function deleteFromSoberTrackDeleteArray(aBlock) {
    "use strict";
    if (mEnrolleesData.SoberTrackBlockDelete.length) {
        var i = mEnrolleesData.SoberTrackBlockDelete.length;
        while (i--) {
            var lScheduleIn = mEnrolleesData.SoberTrackBlockDelete[i];
            if (lScheduleIn._id == aBlock._id) {
                mEnrolleesData.SoberTrackBlockDelete.splice(i, 1);
            }
        }
    }
}

function deleteSoberTrackScheduleBlocks() {
    "use strict";
    var lId = mEnrolleesControls.sobertracksDesignChart.calendarId(),
        lSchedule;

    if (mEnrolleesData.SoberTrackBlockDelete.length) {
        var i = mEnrolleesData.SoberTrackBlockDelete.length;

        while (i--) {
            lSchedule = mEnrolleesData.SoberTrackBlockDelete[i];
            if (isNullOrUndefined(lSchedule.Id) || lSchedule.Id == -1) {
                deleteFromUIDesignChart(lId, lSchedule);
                mEnrolleesData.SoberTrackBlockDelete.splice(i, 1);
            }
        }

        if (mEnrolleesData.SoberTrackBlockDelete.length) {
            deleteEventDesignChart(lId, mEnrolleesData.SoberTrackBlockDelete);
        }

    } else {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackNoBlocksToDelete'));
    }
}

function afterRender_SoberTracksDesignChart(event, elt) {
    "use strict";
    if (event.ScheduleType == 101) {
        elt.addClass("randomBlockout");
    }
}

function comparedEventHasBeenDragged(aEvent) {
    "use strict";
    if (aEvent.start._ambigZone) {
        return true;
    } else {
        return false;
    }
}

function hasBeenDragged(aStart) {
    "use strict";
    if (aStart._ambigZone) {
        return true;
    } else {
        return false;
    }
}

function isOverlap(event, lTimezone) {
    "use strict";
    var lEvents = $('#uSoberTrackDesignChart').fullCalendar('clientEvents'),
        lNewEvent = event,
        lPlacedEvents = [],
        lNewEventsSplit = [];
    //first we split up objects to by day
    //second we create easy to work with objects and place them in lPlacedEvents;
    for (var i = 0; i < lEvents.length; i++) {
        if (!isNullOrUndefined(lEvents[i])) {
            //if it's a drag dont push that similar one in lEvents to lPlacedEvents, so we wont compare
            var lEvent = lEvents[i];
            if (lEvent._id != event._id) {
                var lMultipleDays = isMoreThanOneDayBlock(lEvent.start, lEvent.end);
                var lSoberTrackOverlapObjects = new SoberTrackOverlapObject(lEvent.start, lEvent.end, lEvent.Id, lEvent._id);
                if (lMultipleDays > 1) {
                    var lSplitEvents = splitEventsByDay(lSoberTrackOverlapObjects, lMultipleDays);
                    for (var k = 0; k < lSplitEvents.length; k++) {
                        if (!isNullOrUndefined(lSplitEvents[k])) {
                            var lSplitEvent = lSplitEvents[k];
                            var lSoberTrackOverlapObject = new SoberTrackOverlapObject(lSplitEvent.start, lSplitEvent.end, lSplitEvent.Id, lSplitEvent._id);
                            lPlacedEvents.push(lSoberTrackOverlapObject);
                        }
                    }
                } else {
                    lPlacedEvents.push(lSoberTrackOverlapObjects)
                }
            }
        }

    }

    //split up new events if needed

    var lNewEventMultipleDays = isMoreThanOneDayBlock(event.start, event.end);
    var lNewSoberTrackObject = new SoberTrackOverlapObject(event.start, event.end, event.Id, event._id);
    if (lNewEventMultipleDays > 1) {
        var lNewSplitEvents = splitEventsByDay(lNewSoberTrackObject, lNewEventMultipleDays);
        for (var k = 0; k < lNewSplitEvents.length; k++) {
            if (!isNullOrUndefined(lNewSplitEvents[k])) {
                var lNewSplitEvent = lNewSplitEvents[k];
                var lNewSplitSoberTrackObject = new SoberTrackOverlapObject(lNewSplitEvent.start, lNewSplitEvent.end, lNewSplitEvent.Id, lNewSplitEvent._id);
                lNewEventsSplit.push(lNewSplitSoberTrackObject);
            }
        }
    } else {
        lNewEventsSplit.push(lNewSoberTrackObject);
    }

    //compare array and check for matching objects from lneweventsplit to lplacedevents
    var lOverlaps = false;

    for (var i = 0; i < lNewEventsSplit.length; i++) {
        var lNew = lNewEventsSplit[i];
        //compare this one to all the placed ones
        for (var k = 0; k < lPlacedEvents.length; k++) {
            var lPlaced = lPlacedEvents[k];
            if (!(lPlaced.start >= lNew.end || lPlaced.end <= lNew.start)) {
                return true;
            } else {
                lOverlaps = false;
            }
        }
    }

    return lOverlaps;

}

function SoberTrackOverlapObject(aStart, aEnd, aId, a_Id) {
    "use strict";
    //if dragged we need to fix start and end
    if (hasBeenDragged(aStart)) {
        var lStartClone = aStart.clone(),
            lEndClone = aEnd.clone(),
            lStartClone = lStartClone.add(getOffsetOfSaveDate(), 'minutes'),
            lEndClone = lEndClone.add(getOffsetOfSaveDate(), 'minutes');

        this.start = lStartClone._d;
        this.end = lEndClone._d;
    } else if (moment.isMoment(aStart)) {
        var lStartClone = aStart.clone(),
            lEndClone = aEnd.clone();

        this.start = lStartClone._d;
        this.end = lEndClone._d;
    } else {
        this.start = aStart;
        this.end = aEnd;
    }

    this.Id = aId;
    this._id = a_Id;
}

function splitEventsByDay(aEventObject, aMoreThanOneDay, aSecondEvent) {
    "use strict";
    var lScheduleEvent = aEventObject,
        lStartDay = moment(lScheduleEvent.start),
        lEndDay = moment(lScheduleEvent.end),
        lTotalDays = aMoreThanOneDay;

    var lScheduleObjects = [];

    for (var i = 0; i < lTotalDays; i++) {
        var lNewEventObject = {};
        var lStartDayClone = lStartDay.clone();
        var lEndDayClone = lEndDay.clone();
        if (i == 0) {
            lNewEventObject.start = lStartDayClone._d;
            lNewEventObject.end = (lEndDayClone.add(-(lTotalDays - 1), 'days'))._d;
        }
        else if (i == (lTotalDays - 1)) {
            lNewEventObject.start = (lStartDayClone.add(i, 'days'))._d;
            lNewEventObject.end = lEndDayClone._d;
        }
        else {
            lNewEventObject.start = (lStartDayClone.add(i, 'days'))._d;
            lNewEventObject.end = (lEndDayClone.add(-(lTotalDays - (i + 1)), 'days'))._d;
        }
        lNewEventObject.Id = lScheduleEvent.Id + i;
        lNewEventObject._id = lScheduleEvent._id || i;

        lScheduleObjects.push(lNewEventObject);
    }

    return lScheduleObjects;
}
function SoberTrackScheduleBlockDetailsDrag(aStart, aNewEndTime, aScheduleType, aTimeZone, aId, a_Id) {
    "use strict";
    var lStartClone = aStart.clone(),
        lEndTimeClone = aNewEndTime.clone(),
        lTimeZone = aTimeZone,
        lStartClone = lStartClone.add(getOffsetOfSaveDate(), 'minutes'),
        lEndTimeClone = lEndTimeClone.add(getOffsetOfSaveDate(), 'minutes');

    this.start = lStartClone._d;
    this.end = lEndTimeClone._d;
    this.color = getResultLiveColor(null, null, null, aScheduleType);
    this.textColor = "#000";
    this.newer = true;
    this.ScheduleType = aScheduleType;
    this.Id = -3;
    this.durationEditable = false;
    this.HasBeenDragged = true;
    this._id = a_Id;
    this.NumberOfTest = 0;
}

function itEndsAtMidnight(aEventObject, isMoment) {
    "use strict";
    var lEventObject = aEventObject;


    var lEndHour = lEventObject.end.getHours();


    if (lEndHour == 0) {
        return true;
    }

    return false;

}

function itPassesOvernight(aEventObject) {
    "use strict";
    var lEventObject = aEventObject,
        lStartHour = lEventObject.start.getHours(),
        lEndHour = lEventObject.end.getHours();

    if (lEndHour < lStartHour) {
        return true;
    } else {
        return false;
    }
}
function isMoreThanOneDayBlock(lStartDay, lEndDay) {
    "use strict";
    var lStartDay = moment(lStartDay),
        lEndDay = moment(lEndDay),
        lEndDayDifference = -(lStartDay.diff(lEndDay, 'days') - 1);
    return lEndDayDifference;
}

/**
 * Triggered when dragging stops and the event has moved to a different day/time.
 * function( event, delta, revertFunc, jsEvent, ui, view ) { }
 * @param {*} aEvent  is an Event Object that hold the event’s information (date, title, etc). Call hasTime on the event’s start/end to see if it has been dropped in a timed or all-day area
 * @param {*} aDayDelta   is a Duration Object that represents the amount of time the event was moved by. Available in version 2.0.1 and later.
 * @param {*} aRevertFunc  is a function that, if called, reverts the event’s start/end date to the values before the drag. This is useful if an ajax call should fail.
 */
function eventDrop_SoberTracksDesignChart(aEvent, aDayDelta, aRevertFunc) {
    "use strict";
    mEnrolleesData.SoberTrackBlockDelete = [];
    var lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId),
        lOverlaps = false,
        lMoreThanOneDay = isMoreThanOneDayBlock(aEvent.start, aEvent.end),
        lEventClone = $.extend({}, aEvent),
        lEvent = new SoberTrackScheduleBlockDetailsDrag(aEvent.start, aEvent.end, aEvent.ScheduleType, lTimeZone, aEvent.Id, aEvent._id),
        lEventMulti;
    lEvent.NumberOfTest = aEvent.NumberOfTest;
    //check if lnewendtime is good
    if (itEndsAtMidnight(lEvent)) {
        var lMinusMinuteEndTime = moment(lEvent.end);
        lMinusMinuteEndTime = lMinusMinuteEndTime.add(-1, 'minutes');
        lEvent.end = lMinusMinuteEndTime._d;
    }

    if (!itPassesOvernight(lEvent)) {
        if (isOverlap(lEvent, lTimeZone.TimeZoneName)) {
            lOverlaps = true;

            if (lOverlaps) {
                aRevertFunc();
                //saveSoberTrackScheduleCreated(true);
                mActivityNotification.addNotification(localizeWrapper('cSoberTrackNoOverlap'));
            }
        }

        if (!lOverlaps) {
            mActivityNotification.addNotification(localizeWrapper('cSoberTrackEventDragged'));
            flashRule('button', 'saveSoberTrack');
        }
    } else {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackSchedulePassesDay'));
        aRevertFunc();
    }
}

/**
 *  Full Calendar Event
 * Triggered when a date/time selection is made.
 * function( start, end, jsEvent, view, [ resource ] )
 * CREATION PHASE- When creating a block in the UI. 
 * @param {*} aStart 
 * @param {*} aEnd 
 * @param {*} aEvent jsEvent
 * @param {*} aView 
 */
function selectEventHandler_SoberTrackDesignChart(aStart, aEnd, aEvent, aView,aResource) {
    "use strict";
    console.log('selectEventHandler (select)',aEvent )
    mEnrolleesData.SoberTrackBlockDelete = [];
    var lDontSelect = false,
       
        lScheduleType = $('#uSoberTrackDesignType select').val(),
        lScheduleType = (lScheduleType == 1) ? 101 : 501,        
        lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lNewEndTime = meetScheduleTimeDateRules(aStart, aEnd, lScheduleType, false, lEnrollee.OrganizationId),
        aStartClone = aStart.clone(),
        aEndClone = aEnd.clone(),
        lMoreThanOneDay = isMoreThanOneDayBlock(aStart, aEnd),
        lEventObject = new SoberTrackScheduleBlockDetails(aStart, lNewEndTime, lScheduleType, lTimeZone, -2),
         lScheduleDetails = uScheduleDetailsCreate(lEventObject),
        lEventMulti;
    //check if lnewendtime is good
    if (itEndsAtMidnight(lEventObject)) {
        var lMinusMinuteEndTime = moment(lEventObject.end);
        lMinusMinuteEndTime = lMinusMinuteEndTime.add(-1, 'minutes');
        lEventObject.end = lMinusMinuteEndTime._d;
    }

    if (!itPassesOvernight(lEventObject)) {
        if (isOverlap(lEventObject, lTimeZone.TimeZoneName)) {
            lDontSelect = true;
            if (lDontSelect) {
                mActivityNotification.addNotification(localizeWrapper('cSoberTrackNoOverlap'));
            }
        }

        if (!lDontSelect) {
            $(mEnrolleesControls.sobertracksDesignChart.calendarId()).fullCalendar('renderEvent', specialEventLayout_SoberTracksDesignChart(aStart, aEnd), true);
        }
    } else {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackSchedulePassesDay'));
    }
}

/**
 * 
 * Triggered when event dragging begins.
 * function( event, jsEvent, ui, view ) { }
 * @param {*} event 
 * @param {*} jsEvent 
 * @param {*} ui 
 * @param {*} view 
 */
function eventDragStop_SoberTracksDesignChart(event, jsEvent, ui, view) {
    "use strict";
    var lEdit = event,
        lTitle,
        lScheduleType = lEdit.ScheduleType;
    if (lScheduleType == 101) {
        event.title = '';
        event.Name = '';
        lTitle = localizeText('cSoberTrackRandomTest') + uScheduleDetailsCreate(event);
        event.title = lTitle;
        event.Name = localizeText('cSoberTrackRandomTest');
    }
    else {
        event.title = '';
        event.Name = '';
        lTitle = localizeText('cSoberTrackFixedTest');
        event.title = lTitle;
        event.Name = localizeText('cSoberTrackFixedTest');
    }
    event.ScheduleType = lScheduleType;
    event.newer = true;
}

/**
 * This is a SoberTrack Formatter
 * TODO: Convert to sobertrackScheduleDetailsEventFormatter
 * @param {*} aEvent SoberTrack Event
 * @returns 
 */
function uScheduleDetailsCreate(aEvent) {
    "use strict";
    var lHourText = localizeText('cTimelineHour'),
        lNumberOfTest = aEvent.NumberOfTest,
        lDesignDurationSelect = aEvent.MinuteBetweenTest/60;

    if(lDesignDurationSelect > 1){
        lHourText = localizeText('cTimelineHourPlural');
    }

    var lDesignDuration = localizeText('cSoberTrackDurationBetweenTests') + ': ' + lDesignDurationSelect + ' ' + lHourText;
    var lTestsPerBlock = localizeText('cSoberTrackNumberTests') + ': ' + lNumberOfTest;
    var lScheduleDetails = '\n' + lDesignDuration + '\n' + lTestsPerBlock;
    return lScheduleDetails;
}

/**
 * Event triggered when selecting and Event is NOT Editable. 
 * @param {*} aStart 
 * @param {*} aEnd 
 * @param {*} aEvent 
 * @returns 
 */
function specialEventLayout_SoberTracksDesignChart(aStart, aEnd) {
    "use strict";
    var lScheduleType = $('#uSoberTrackDesignType select').val(),
        lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
    if (lScheduleType == 1) {
        var lNewEndTime = meetScheduleTimeDateRules(aStart, aEnd, 101, false, lEnrollee.OrganizationId),
            lDetails = new SoberTrackScheduleBlockDetails(aStart, lNewEndTime, 101, lTimeZone),
            lScheduleDetails = uScheduleDetailsCreate(lDetails);

        lDetails.Name = localizeText('cSoberTrackRandomTest');
        lDetails.title = localizeText('cSoberTrackRandomTest') + lScheduleDetails;
    }
    else {
        var lNewEndTime = meetScheduleTimeDateRules(aStart, aEnd, 501, false, lEnrollee.OrganizationId),
            lDetails = new SoberTrackScheduleBlockDetails(aStart, lNewEndTime, 501, lTimeZone);

        lDetails.Name = localizeText('cSoberTrackFixedTest');
        lDetails.title = localizeText('cSoberTrackFixedTest');

    }

    return lDetails;
}

function SoberTrackScheduleBlockDetails(aStart, aNewEndTime, aScheduleType, aTimeZone, aId) {
    "use strict";
    var lStartClone = aStart.clone(),
        lEndTimeClone = aNewEndTime.clone(),
        lTimeZone = aTimeZone,
        lStartClone = lStartClone.add(getOffsetOfSaveDate(), 'minutes'),
        lEndTimeClone = lEndTimeClone.add(getOffsetOfSaveDate(), 'minutes');
    var lDesignDuration = parseInt($('#uSoberTrackDesignDuration select').val()),
        lDesignDuration = lDesignDuration * 60,
        lTestsPerBlock = parseInt($('#uSoberTrackDesignTestsPerBlock select').val());

    this.start = lStartClone._d;
    this.end = lEndTimeClone._d;
    this.color = getResultLiveColor(null, null, null, aScheduleType);
    this.textColor = "#000";
    this.newer = true;
    this.ScheduleType = aScheduleType;
    this.Id = aId || -1;
    this.durationEditable = false;
    this.MinuteBetweenTest = lDesignDuration||0;
    this.NumberOfTest = lTestsPerBlock || 0;
}

function SoberTrackScheduleBlockDetailsEdit(aStart, aNewEndTime, aScheduleType, aTimeZone, aId, a_Id) {
    "use strict";
    var lStartClone = aStart.clone(),
        lEndTimeClone = aNewEndTime.clone(),
        lTimeZone = aTimeZone;

    this.start = lStartClone._d;
    this.end = lEndTimeClone._d;
    this.color = getResultLiveColor(null, null, null, aScheduleType);
    this.textColor = "#000";
    this.newer = true;
    this.ScheduleType = aScheduleType;
    this.Id = aId;
    this._id = a_Id;
    this.durationEditable = false;
}

function meetScheduleTimeDateRules(aStart, aEnd, aScheduleType, aEdit, aOrganizationId) {
    "use strict";
    var lStartTime = aStart,
        lEndTime = aEnd,
        lTestPeriod = 30;

    if (aScheduleType == 101 && !aEdit) {
        var lDurationBetween = parseInt($('#uSoberTrackDesignDuration select').val());
        var lTestPerBlock = parseInt($('#uSoberTrackDesignTestsPerBlock select').val());
    } else if (aScheduleType == 101 && aEdit) {
        var lDurationBetween = 1;
        var lTestPerBlock = parseInt($('#SoberTrackEditNumberofTestsDropdown').val());
    } else if (aScheduleType == 501) {
        var lStartDayClone = lStartTime.clone();
        var lNewEndTime = lStartDayClone.add(checkOrganizationProperty(aOrganizationId, "sobertrack_fixed_test_time"), 'minutes');
        return lNewEndTime;
    } else {
        var lDurationBetween = 60;
        var lTestPerBlock = 1;
    }


    function getTotalTime(lTestPeriod, lDurationBetween, lTestPerBlock) {
        var lTotal;
        if (lTestPerBlock > 1) {
            lDurationBetween = lDurationBetween * 60; //60
            lTotal = (lTestPerBlock) * lDurationBetween; //2 * 60 = 120
            lTestPeriod = lTestPerBlock * lTestPeriod; //2 * 30 = 60
            lTotal = lTotal + lTestPeriod; // 120 + 60 = 180
        }
        else {
            lTotal = lTestPeriod;
        }

        return lTotal;
    };

    function getTotalDays(lStartDay, lEndDay) {
        "use strict";
        var lEndDayDifference = -(lStartDay.diff(lEndDay, 'days') - 1),
            lEndDayDifference = lEndDayDifference - 1;
        return lEndDayDifference;
    }
    var lStartDayClone = lStartTime.clone();
    var lNewEndTime = lStartDayClone.add(getTotalTime(lTestPeriod, lDurationBetween, lTestPerBlock), 'minutes');
    lNewEndTime = lStartDayClone.add(getTotalDays(lStartTime, lEndTime), 'days');

    if (lEndTime > lNewEndTime) {
        return lEndTime;
    }
    else {
        return lNewEndTime;
    }
}

function saveSoberTrackScheduleCreated(aIsReverted) {
    "use strict";
    var lScheduleBlockObjects = [],
        lDraggedBlockObjects = [],
        lEvents = $('#uSoberTrackDesignChart').fullCalendar('clientEvents'),
        lDesignDuration,
        lTestsPerDay,
        lTestPeriod,
        lRetests,
        lHasNewEvents = [],
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
        lOrganizationId = lEnrollee.OrganizationId,
        lDesignDuration = parseInt($('#uSoberTrackDesignDuration select').val()),
        lDesignDuration = lDesignDuration * 60,
        lTestsPerBlock = parseInt($('#uSoberTrackDesignTestsPerBlock select').val());


    for (var k = 0; k < lEvents.length; k++) {
        if (lEvents[k].newer) {
            lHasNewEvents.push(lEvents[k]);
            // STOP-2795 
            splitByEventObjectsByDay(lEvents[k], lEvents[k].ScheduleType, lEvents[k].MinuteBetweenTest, lEvents[k].NumberOfTest);
        }
    }

    function splitByEventObjectsByDay(aSoberTrackSchedules, aScheduleType, aDesignDuration, aTestsPerBlock) {
        "use strict";
        var lScheduleEvent = aSoberTrackSchedules,
            lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId),
            lStartDay = lScheduleEvent.start,
            lEndDay = lScheduleEvent.end,
            lTotalDays = -(lStartDay.diff(lEndDay, 'days') - 1),
            lCurrentUserId = gUserDetails.UserId,
            lSchedulePrepObjects = [],
            lDraggedObject = {};
        if (isNullOrUndefined(aIsReverted) && lScheduleEvent.Id != -1) {

            var lOffenderAlcoholSchedBlock = new OffenderAlcoholSchedBlock();
            lOffenderAlcoholSchedBlock.IsActive = 0;
            lOffenderAlcoholSchedBlock.StartDate = lScheduleEvent.StartDate;
            lOffenderAlcoholSchedBlock.StopDate = lScheduleEvent.StopDate;
            lOffenderAlcoholSchedBlock.AppUserId = lScheduleEvent.AppUserId;
            lOffenderAlcoholSchedBlock.EnrolleeId = lScheduleEvent.EnrolleeId;
            lOffenderAlcoholSchedBlock.EnrolleeTimeZone = lScheduleEvent.EnrolleeTimeZone;
            lOffenderAlcoholSchedBlock.ScheduleType = lScheduleEvent.ScheduleType;
            lOffenderAlcoholSchedBlock.OrganizationId = lScheduleEvent.OrganizationId;
            lOffenderAlcoholSchedBlock.DayOfWeek = lScheduleEvent.DayOfWeek;
            lOffenderAlcoholSchedBlock.StartHour = lScheduleEvent.StartHour;
            lOffenderAlcoholSchedBlock.StopHour = lScheduleEvent.StopHour;
            lOffenderAlcoholSchedBlock.Name = lScheduleEvent.Name;
            lOffenderAlcoholSchedBlock.NumberOfTest = lScheduleEvent.NumberOfTest || 0;
            if (lOffenderAlcoholSchedBlock.ScheduleType == 501) {
                lOffenderAlcoholSchedBlock.MinuteBetweenTest = 90;
            } else {
                lOffenderAlcoholSchedBlock.MinuteBetweenTest = lScheduleEvent.MinuteBetweenTest || 0;
            }
            lOffenderAlcoholSchedBlock.Id = lScheduleEvent.Id;
            lDraggedBlockObjects.push(lOffenderAlcoholSchedBlock);

            //if its dragged change time offset
            if (comparedEventHasBeenDragged(lScheduleEvent)) {
                lStartDay = lStartDay.add(getOffsetOfSaveDate(), 'minutes');
                lEndDay = lEndDay.add(getOffsetOfSaveDate(), 'minutes');
            }

        } else if (aIsReverted && lScheduleEvent.Id != -1) {
            lStartDay = lStartDay.add(-getOffsetOfSaveDate(), 'minutes');
            lEndDay = lEndDay.add(-getOffsetOfSaveDate(), 'minutes');
        } else if (comparedEventHasBeenDragged(lScheduleEvent)) {
            lStartDay = lStartDay.add(getOffsetOfSaveDate(), 'minutes');
            lEndDay = lEndDay.add(getOffsetOfSaveDate(), 'minutes');
        }


        for (var i = 0; i < lTotalDays; i++) {
            var lOffenderAlcoholPrepBlock = {},
                lStartDayClone = lStartDay.clone(),
                lEndDayClone = lEndDay.clone();

            if (i == 0) {
                lOffenderAlcoholPrepBlock.start = lStartDayClone._d
                lOffenderAlcoholPrepBlock.end = (lEndDayClone.add(-(lTotalDays - 1), 'days'))._d;
            }
            else if (i == (lTotalDays - 1)) {
                lOffenderAlcoholPrepBlock.start = (lStartDayClone.add(i, 'days'))._d;
                lOffenderAlcoholPrepBlock.end = lEndDayClone._d;
            }
            else {
                lOffenderAlcoholPrepBlock.start = (lStartDayClone.add(i, 'days'))._d;
                lOffenderAlcoholPrepBlock.end = (lEndDayClone.add(-(lTotalDays - (i + 1)), 'days'))._d;
            }

            lOffenderAlcoholPrepBlock.title = lScheduleEvent.title
            lOffenderAlcoholPrepBlock.Name = lScheduleEvent.Name

            lOffenderAlcoholPrepBlock.Id = -1;

            lSchedulePrepObjects.push(lOffenderAlcoholPrepBlock);
        }

        for (var i = 0; i < lSchedulePrepObjects.length; i++) {
            //each object create a day for them along with other rules, after day created send each to lScheduleBlockObjects
            var lOffenderAlcoholSchedBlock = new OffenderAlcoholSchedBlock(),
                lSchedPrepObject = lSchedulePrepObjects[i],
                dayOfWeek = getDayOfWeekOfSplitDays(lSchedPrepObject),
                hourofDayStart = getHourOfDayOfSplitDays(lSchedPrepObject.start),
                hourofDayStop = getHourOfDayOfSplitDays(lSchedPrepObject.end);

            lOffenderAlcoholSchedBlock.StartDate = convertTimeToUTC(new Date(), lTimeZone.TimeZoneName);
            lOffenderAlcoholSchedBlock.StopDate = convertTimeToUTC(new Date('12/31/9999'), lTimeZone.TimeZoneName);
            lOffenderAlcoholSchedBlock.AppUserId = lCurrentUserId;
            lOffenderAlcoholSchedBlock.EnrolleeId = mEnrolleesData.OffenderCurrentId;
            lOffenderAlcoholSchedBlock.EnrolleeTimeZone = lTimeZone.TimeZoneName;
            lOffenderAlcoholSchedBlock.ScheduleType = aScheduleType;
            lOffenderAlcoholSchedBlock.OrganizationId = lOrganizationId;
            lOffenderAlcoholSchedBlock.DayOfWeek = dayOfWeek;
            lOffenderAlcoholSchedBlock.StartHour = hourofDayStart;
            lOffenderAlcoholSchedBlock.StopHour = hourofDayStop;
            lOffenderAlcoholSchedBlock.Name = lSchedPrepObject.Name;
            lOffenderAlcoholSchedBlock.NumberOfTest = aTestsPerBlock;
            if (lOffenderAlcoholSchedBlock.ScheduleType == 501) {
                lOffenderAlcoholSchedBlock.MinuteBetweenTest = 90;
            } else {
                lOffenderAlcoholSchedBlock.MinuteBetweenTest = aDesignDuration;
            }
            
            lOffenderAlcoholSchedBlock.Id = lSchedPrepObject.Id;

            lScheduleBlockObjects.push(lOffenderAlcoholSchedBlock);

            function getDayOfWeekOfSplitDays(aSchedPrepObject) {
                "use strict";
                var lDay = getDayOfWeek(aSchedPrepObject.start.getDay());
                return lDay;
            }

            function getHourOfDayOfSplitDays(aSchedPrepObjectHour) {
                "use strict";
                var lHour = aSchedPrepObjectHour.getHours(),
                    lMinute = aSchedPrepObjectHour.getMinutes();

                if (lMinute == 0) {
                    lMinute = '00';
                }

                if (lHour < 10) {
                    lHour = '0' + lHour;
                }

                var lHourTime = lHour + ':' + lMinute;
                return lHourTime;
            }
        }
    }

    if (lScheduleBlockObjects.length && lHasNewEvents.length) {
        WriteMultiple(lScheduleBlockObjects, ScheduleDesign_OnSuccess, ScheduleDesign_OnFailure);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackNothingSaved'));
    }


    function ScheduleDesign_OnSuccess(aScheduleType, aData) {
        "use strict";
        
        if (lDraggedBlockObjects.length) {
            WriteMultiple(lDraggedBlockObjects, ScheduleDeleteDrag_OnSuccess, ScheduleDeleteDrag_OnFailure);
        } else {
            var lTimezone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
            var lAlcoholScheduleCommand = new AlcoholScheduleCommand();

            lAlcoholScheduleCommand.EnrolleeId = mEnrolleesData.OffenderCurrentId;
            lAlcoholScheduleCommand.EnrolleeTimeZone = lTimezone.TimeZoneName;
            if (!$('.SoberTrackDeviceButton').hasClass('Disabled')) {
                getSoberTrackOnDemandIsReady_OnSuccess($('.SoberTrackDeviceButton'), aData);                        
            }
             WriteSingle(lAlcoholScheduleCommand, AlcoholScheduleCommand_OnSuccess, AlcoholScheduleCommand_OnFailure);
        }
    }

    function AlcoholScheduleCommand_OnSuccess(aScheduleType) {
        "use strict";
        var viewEvents = $('#uSoberTrackDesignChart').fullCalendar('getView');
        events_SoberTracksDesignChart(viewEvents.start, viewEvents.end, viewRender_SoberTracksDesignChart);
        var lScheduleType = aScheduleType,
            lIdNotCreated = [],
            lIdCreated = [];

        mActivityNotification.addNotification(localizeWrapper('cSoberTrackScheduleBlocksSaved'));
    }

    function AlcoholScheduleCommand_OnFailure(a, b, c, d) {
        "use strict";

    }

    function ScheduleDesign_OnFailure(a, b, c, d, e) {
        "use strict";
        var viewEvents = $('#uSoberTrackDesignChart').fullCalendar('getView');
        events_SoberTracksDesignChart(viewEvents.start, viewEvents.end, viewRender_SoberTracksDesignChart);
    }

    function ScheduleDeleteDrag_OnSuccess(aScheduleType, aData) {
        var lTimezone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
        var lAlcoholScheduleCommand = new AlcoholScheduleCommand();

        lAlcoholScheduleCommand.EnrolleeId = mEnrolleesData.OffenderCurrentId;
        lAlcoholScheduleCommand.EnrolleeTimeZone = lTimezone.TimeZoneName;

        WriteSingle(lAlcoholScheduleCommand, AlcoholScheduleCommand_OnSuccess, ScheduleDeleteDrag_OnFailure);
    }

    function ScheduleDeleteDrag_OnFailure(a, b, c, d, e) {
        "use strict"

    }
}

function flashRule(input, classButton) {
    "use strict";
    if (input == 'type') {
        $("#uSoberTrackDesignType").addClass('SelectedScheduleRule').fadeIn(300).fadeOut(300).fadeIn(300).fadeOut(300).fadeIn(300).fadeOut(300).fadeIn(300, function () {
            $(this).removeClass('SelectedScheduleRule');
        });
    }

    if (input == 'button' && classButton == 'saveSoberTrack') {
        $(".saveSoberTrack").fadeIn(300).fadeOut(300).fadeIn(300).fadeOut(300).fadeIn(300);
    }
}

function designMakeNotification(lScheduleType) {
    "use strict";
    if (lScheduleType == 101) {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackRandomSaved'));
    }
    else if (lScheduleType == 501) {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackFixedSaved'));
    }
}

function viewRender_SoberTracksDesignChart() {
    "use strict";
    var aId = mEnrolleesControls.sobertracksDesignChart.calendarId();
    $(aId).fullCalendar('removeEvents');
    $(aId).fullCalendar('addEventSource', mEnrolleesControls.sobertracksDesignChart.getDataSource());
    $(aId).fullCalendar('rerenderEvents');
}

function events_SoberTracksDesignChart(aStartEvent, aEndEvent, aCallback) {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId,
        lStartDate = moment(aStartEvent.format()),
        lEndDate = moment(aEndEvent.format());

    getSoberTrackDesignEventSchedules(lEnrolleeId, lStartDate, lEndDate, null, function (aOffenderAlcoholSchedBlock) {
        if (lEnrolleeId == mEnrolleesData.OffenderCurrentId) {
            mEnrolleesControls.sobertracksDesignChart.setDataSource([]);
            mEnrolleesControls.sobertracksDesignChart.setDataSource(aOffenderAlcoholSchedBlock);
            if (aCallback) {
                aCallback();
            }
        }
        $('.loadingGif').hide();
    });

}

function getSoberTrackDesignEventSchedules(aEnrolleeId, aStartDate, aEndDate, aParams, aCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lEnrolleeSchedules = [],
        lTimeZone = getEnrolleeTimeZone(aEnrolleeId),
        lKey;

    lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.OffenderAlcoholSchedBlock.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderAlcoholSchedBlock_OnSuccess, offenderAlcoholSchedBlock_OnFail, [aStartDate, aEndDate, aParams], null, 0, true);

    function offenderAlcoholSchedBlock_OnSuccess(aParams, aData) {
        var lOffenderAlcoholSchedBlockDisplay = [];
        var lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
        var viewEvents = $('#uSoberTrackDesignChart').fullCalendar('getView');
        for (var i = 0; i < aData.length; i++) {
            if (aData[i].ScheduleType == 101 || aData[i].ScheduleType == 501) {
                var lOffenderAlcoholSchedBlock = new displayOffenderAlcoholSchedBlock(aData[i], lTimeZone, viewEvents.start, viewEvents.end);
                lOffenderAlcoholSchedBlock.durationEditable = false;
                lOffenderAlcoholSchedBlockDisplay.push(lOffenderAlcoholSchedBlock);
            }
        }

        if (aCallback) {
            aCallback(lOffenderAlcoholSchedBlockDisplay);
        }
    }

    function offenderAlcoholSchedBlock_OnFail(a, b) {
    }
}

function DragDesignEvent_OnSuccess(aType) {
    "use strict";
    if (aType == 301) {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackFixedTestSave'));
    } else {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackRandomSave'));
    }

}

function DragDesignEvent_OnFailure() {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cSoberTrackNotSaved'));
}

function rightClickHandler_SoberTracksDesignChart(aEvent, deleteOnly) {
    "use strict";
    var lHtml = [];
    var lButtonCommandBar = GenerateButtonCommandBar();
    var lEdit = aEvent;

    mEnrolleesControls.sobertracksDesignChart.addExtraData("Schedule", lEdit);

    if (isNullOrUndefined(aEvent.Id) || aEvent.Id == -1) {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackSaveFirst'));

    } else if(aEvent.newer) {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackSaveFirstAfterDrag'));
    } else {
        lHtml.push('<div class="Button LargeIconButton DeleteSingleDayIcon" onclick="ClickEventDesignChart(1);">' + localizeWrapper('cEnrolleeEditSchedule') + '</div>');

        DisplayModal(localizeWrapper('cEnrolleeEditMode'), lHtml.join(''), 'CloseLiveCalendarModal()', true);
    }

    if (schedulesExistThatHaveNotBeenSaved()) {
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeSchedulesNotSaved'));
    }


}

function schedulesExistThatHaveNotBeenSaved() {
    "use strict";

    var lEvents = $('#uSoberTrackDesignChart').fullCalendar('clientEvents');

    for (var k = 0; k < lEvents.length; k++) {
        if (lEvents[k].newer) {
            return true;
        }
    }

    return false;
}

function ClickEventDesignChart(aChangeType, aNew) {
    "use strict";
    var aId = mEnrolleesControls.sobertracksDesignChart.calendarId();
    var lSchedule = mEnrolleesControls.sobertracksDesignChart.getExtraData("Schedule");

    editEventDesignChart(aId, lSchedule);

}

function editEventDesignChart(aId, aSchedule) {
    "use strict";
    var lPopupName = localizeWrapper('cEnrolleeEditSchedule');
    var lSchedule = aSchedule;

    if (ModalIsOpen()) {
        CloseModal();
    }
    SoberTrackScheduleEdit_Init(lPopupName, true, lSchedule);
}

function SoberTrackScheduleEdit_Init(aHeaderText, aIsCalendar, lSchedule) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lHtml = [];
    var lTitle = lSchedule.Name;
    var lLabel = localizeText('cSoberTrackTitleLabel');
    var lCurrentNumber = lSchedule.NumberOfTest;

    lHtml.push('<div id="SoberTrackEditDialog">');
    lHtml.push('<div id="SoberTrackTitleEdit">');
    lHtml.push('<div id="soberTrackTitleLabel"><label>' + lLabel + '</label></div>');
    lHtml.push('<textarea id="titleChange" class="Validate ValidateRequired ValidateLength Validate255Length" rows="4" cols="40">');
    lHtml.push(lTitle);
    lHtml.push('</textarea>');
    if (lSchedule.ScheduleType == 101) {
        lHtml.push('<div id="SoberTrackEditNumberofTests">');
        lHtml.push('<span>Number of Tests Per Block</span>')
        lHtml.push(populateSoberTrackEditNumberTest(lCurrentNumber))
        lHtml.push('</div>');
    }
    lHtml.push('</div>');
    lHtml.push('</div>');

    mEnrolleesControls.sobertracksDesignChart.setEditingSchedule(lSchedule);

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uSaveSoberTrackEditButton_OnClick()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'CalendarClosePopup()'));

    DisplayPopup(aHeaderText, lHtml.join(''), lButtonBar, true, aIsCalendar);

}

function populateSoberTrackEditNumberTest(aCurrentNumber) {
    "use strict";
    var lCurrentNumber = aCurrentNumber,
        lHtml = [],
        isSelected;

    lHtml.push('<select id="SoberTrackEditNumberofTestsDropdown" onchange="soberTrackEditTimeCheck();">');
    for (var i = 1; i <= 3; i++) {
        if(aCurrentNumber == i) { isSelected = 'selected'} else { isSelected = ''}
        lHtml.push('<option val="' + i + '" '+ isSelected +'>')
        lHtml.push(i)
        lHtml.push('</option>')
    }
    lHtml.push('</select>');

    return lHtml.join('');

}

function soberTrackEditTimeCheck() {
    "use strict";
    var lSchedule = mEnrolleesControls.sobertracksDesignChart.getExtraData("Schedule"),
        lNumberOfTest = $('#SoberTrackEditNumberofTestsDropdown').val();

    if (lNumberOfTest > lSchedule.NumberOfTest) {
        var lNewEndTime = meetScheduleTimeDateRules(lSchedule.start, lSchedule.end, lSchedule.ScheduleType, true, lSchedule.OrganizationId);
        var lEventObject = new SoberTrackScheduleBlockDetailsEdit(lSchedule.start, lNewEndTime, lSchedule.ScheduleType, lSchedule.EnrolleeTimeZone, lSchedule.Id, lSchedule._id);

        if (!itPassesOvernight(lEventObject)) {
            if (isOverlap(lEventObject, lSchedule.EnrolleeTimeZone)) {
                $('#SoberTrackEditNumberofTestsDropdown').val(lSchedule.NumberOfTest);
                mActivityNotification.addNotification(localizeWrapper('cSoberTrackNoOverlap'));
            } else {
                mEnrolleesControls.sobertracksDesignChart.addExtraData("ScheduleEdit", lEventObject);
            }

        } else {
            $('#SoberTrackEditNumberofTestsDropdown').val(lSchedule.NumberOfTest);
            mActivityNotification.addNotification(localizeWrapper('cSoberTrackSchedulePassesDay'));
        }
    }
}

function getOffsetOfSaveDate(aDate) {
    "use strict";
    if (aDate) return aDate.getTimezoneOffset();

    return new Date().getTimezoneOffset();;
}

function uSaveSoberTrackEditButton_OnClick() {
    "use strict";
    var lSchedule = mEnrolleesControls.sobertracksDesignChart.getEditingSchedule(),
        lTitle = $('#titleChange').val(),
        lNumberOfTest = $('#SoberTrackEditNumberofTestsDropdown').val(),
        lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId),
        hourofDayStop;

    mEnrolleesControls.SoberTrackEditTitleValidate = new Validator('uPopupContainer2', mRegexValidation);


    if (mEnrolleesControls.SoberTrackEditTitleValidate.IsValid()) {
        if (lNumberOfTest > lSchedule.NumberOfTest) {
            var lScheduleEdit = mEnrolleesControls.sobertracksDesignChart.getExtraData("ScheduleEdit");
            hourofDayStop = getHourOfDayOfSplitDays(lScheduleEdit.end);
        } else {
            hourofDayStop = lSchedule.StopHour;
        }

        var lOffenderAlcoholSchedBlock = new OffenderAlcoholSchedBlock();
        lOffenderAlcoholSchedBlock.StartDate = lSchedule.StartDate;
        lOffenderAlcoholSchedBlock.StopDate = lSchedule.StopDate;
        lOffenderAlcoholSchedBlock.AppUserId = lSchedule.AppUserId;
        lOffenderAlcoholSchedBlock.EnrolleeId = lSchedule.EnrolleeId;
        lOffenderAlcoholSchedBlock.EnrolleeTimeZone = lSchedule.EnrolleeTimeZone;
        lOffenderAlcoholSchedBlock.ScheduleType = lSchedule.ScheduleType;
        lOffenderAlcoholSchedBlock.OrganizationId = lSchedule.OrganizationId;
        lOffenderAlcoholSchedBlock.DayOfWeek = lSchedule.DayOfWeek;
        lOffenderAlcoholSchedBlock.StartHour = lSchedule.StartHour;
        lOffenderAlcoholSchedBlock.StopHour = hourofDayStop;
        lOffenderAlcoholSchedBlock.Name = lTitle;
        lOffenderAlcoholSchedBlock.NumberOfTest = lNumberOfTest;
        lOffenderAlcoholSchedBlock.MinuteBetweenTest = lSchedule.MinuteBetweenTest;
        lOffenderAlcoholSchedBlock.Id = lSchedule.Id;

        WriteSingle(lOffenderAlcoholSchedBlock, SoberTrackEditEvent_OnSuccess, SoberTrackEditEvent_OnFailure, [lSchedule.ScheduleType]);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cSoberTrackEditNotValid'));
    }

    function getHourOfDayOfSplitDays(aSchedPrepObjectHour) {
        "use strict";
        var lHour = aSchedPrepObjectHour.getHours(),
            lMinute = aSchedPrepObjectHour.getMinutes();

        if (lMinute == 0) {
            lMinute = '00';
        }

        if (lHour < 10) {
            lHour = '0' + lHour;
        }

        var lHourTime = lHour + ':' + lMinute;
        return lHourTime;
    }

}

function SoberTrackEditEvent_OnSuccess(aParams, aData) {
    "use strict";
    var lTimezone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
    var lAlcoholScheduleCommand = new AlcoholScheduleCommand();

    lAlcoholScheduleCommand.EnrolleeId = mEnrolleesData.OffenderCurrentId;
    lAlcoholScheduleCommand.EnrolleeTimeZone = lTimezone.TimeZoneName;

    WriteSingle(lAlcoholScheduleCommand, AlcoholScheduleCommandEdit_OnSuccess, AlcoholScheduleCommandEdit_OnFailure);
}


function AlcoholScheduleCommandEdit_OnSuccess() {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cSoberTrackTitleChange'));
    CloseLiveCalendarModal();
    var viewEvents = $('#uSoberTrackDesignChart').fullCalendar('getView');
    events_SoberTracksDesignChart(viewEvents.start, viewEvents.end, viewRender_SoberTracksDesignChart);
}

function AlcoholScheduleCommandEdit_OnFailure(a, b, c, d) {
    "use strict";

}


function SoberTrackEditEvent_OnFailure() {
    "use strict";
}

function deleteFromUIDesignChart(aId, lSchedule) {
    "use strict";
    var lId = aId;
    $(lId).fullCalendar('removeEvents', lSchedule._id);
}

function deleteEventDesignChart(aId, aSchedules) {
    "use strict";
    var lSchedules = aSchedules,
        lScheduleBlockDelete = [];

    for (var i = 0; i < lSchedules.length; i++) {
        var lSchedule = lSchedules[i];

        $(aId).fullCalendar('removeEvents', lSchedule._id);

        var lOffenderAlcoholSchedBlock = new OffenderAlcoholSchedBlock();
        lOffenderAlcoholSchedBlock.IsActive = 0;
        lOffenderAlcoholSchedBlock.StartDate = lSchedule.StartDate;
        lOffenderAlcoholSchedBlock.StopDate = lSchedule.StopDate;
        lOffenderAlcoholSchedBlock.AppUserId = lSchedule.AppUserId;
        lOffenderAlcoholSchedBlock.EnrolleeId = lSchedule.EnrolleeId;
        lOffenderAlcoholSchedBlock.EnrolleeTimeZone = lSchedule.EnrolleeTimeZone;
        lOffenderAlcoholSchedBlock.ScheduleType = lSchedule.ScheduleType;
        lOffenderAlcoholSchedBlock.OrganizationId = lSchedule.OrganizationId;
        lOffenderAlcoholSchedBlock.DayOfWeek = lSchedule.DayOfWeek;
        lOffenderAlcoholSchedBlock.StartHour = lSchedule.StartHour;
        lOffenderAlcoholSchedBlock.StopHour = lSchedule.StopHour;
        lOffenderAlcoholSchedBlock.Name = lSchedule.Name;
        lOffenderAlcoholSchedBlock.NumberOfTest = lSchedule.NumberOfTest;
        lOffenderAlcoholSchedBlock.MinuteBetweenTest = lSchedule.MinuteBetweenTest;
        lOffenderAlcoholSchedBlock.Id = lSchedule.Id;

        lScheduleBlockDelete.push(lOffenderAlcoholSchedBlock);
    }

    WriteMultiple(lScheduleBlockDelete, ClickDeleteScheduleBlocks_OnSuccess, ClickDeleteScheduleBlocks_OnFailure);

}

function ClickDeleteScheduleBlocks_OnSuccess(aParams, aData) {
    "use strict";
    var lTimezone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
    var lAlcoholScheduleCommand = new AlcoholScheduleCommand();

    lAlcoholScheduleCommand.EnrolleeId = mEnrolleesData.OffenderCurrentId;
    lAlcoholScheduleCommand.EnrolleeTimeZone = lTimezone.TimeZoneName;

    WriteSingle(lAlcoholScheduleCommand, AlcoholScheduleCommandDelete_OnSuccess, AlcoholScheduleCommandDelete_OnFailure);
}

function AlcoholScheduleCommandDelete_OnSuccess(aScheduleType) {
    "use strict";
    var viewEvents = $('#uSoberTrackDesignChart').fullCalendar('getView');
    events_SoberTracksDesignChart(viewEvents.start, viewEvents.end, viewRender_SoberTracksDesignChart);
    var lScheduleType = aScheduleType,
        lIdNotCreated = [],
        lIdCreated = [];

    mActivityNotification.addNotification(localizeWrapper('cSoberTrackEventDeleted'));
    mEnrolleesData.SoberTrackBlockDelete = [];
}

function AlcoholScheduleCommandDelete_OnFailure(a, b, c, d) {
    "use strict";
}

function ClickDeleteScheduleBlocks_OnFailure(aParams, aData) {
    "use strict";
}

function CloseLiveCalendarModal() {
    "use strict";
    ClosePopup();
}

/*****************************************/
/*****Create Schedule Design Rules********/
/*****************************************/
function scheduleDesignRules_ControlInit() {
    "use strict";
    var lTypeDD = null,
        lDurationDD = null,
        lTestsPerDayDD = null,
        lTestPeriodDD = null,
        lNumberRetestsDD = null,
        lCreateTestButton = null;

    lTypeDD = VeritracksUIControls('uSoberTrackDesignType', 'Dropdown', {
        'title': localizeWrapper('cSoberTrackType'),
        'data': {
            'Random': 1,
            'Fixed': 2
        },
        'callback': showhideScheduleRules
    });

    lDurationDD = VeritracksUIControls('uSoberTrackDesignDuration', 'Dropdown', {
        'title': localizeWrapper('cSoberTrackDurationBetweenTests'),
        'data': { '1 hour': 1, '2 hours': 2, '3 hours': 3, '4 hours': 4 }
    });

    lTestsPerDayDD = VeritracksUIControls('uSoberTrackDesignTestsPerBlock', 'Dropdown', {
        'title': localizeWrapper('cSoberTrackNumberTests'),
        'data': { '1': 1, '2': 2, '3': 3 }
    });

    lNumberRetestsDD = VeritracksUIControls('uSoberTrackDesignTestPeriod', 'Dropdown', {
        'title': localizeWrapper('cSoberTrackTestPeriod'),
        'data': { '30': 30, '60': 60, '90': 90, '120': 120, '180': 180 }
    });

    lNumberRetestsDD = VeritracksUIControls('uSoberTrackDesignRetests', 'Dropdown', {
        'title': localizeWrapper('cSoberTrackRetests'),
        'data': { '1': 1, '2': 2, '3': 3, '4': 4, '5': 5 }
    });

}

function VeritracksUIControls(aID, aUIType, aOptions) {
    var mThis = this,
        mTitle = '',
        mData = null,
        mCallBack = null,
        mContent = null,
        mLabel = '';

    var mUI = aUIType;

    if (!isNullOrUndefined(aOptions)) {
        if (!isNullOrUndefined(aOptions.search)) {
            mTitle = aOptions.title;
            mLabel = '<input placeholder="' + mTitle + '" type="text"></input><br />';
        }
        else if (!isNullOrUndefined(aOptions.title)) {
            mTitle = aOptions.title;
            mLabel = '<label>' + mTitle + '</label><br />';
        }
         if (!isNullOrUndefined(aOptions.data)) {
            mData = aOptions.data;
        }
        if (!isNullOrUndefined(aOptions.callback)) {
            mCallBack = aOptions.callback;
        }
    }

    if (mUI == 'Dropdown') {
        $('#' + aID).append(mLabel);
        mContent = DropdownCreate(mData, mCallBack, aID + 'Select');
        mContent.appendTo($("#" + aID));
    }

    function DropdownCreate(data, callback, idName) {
        var s = $('<select id="' + idName + '"/>').on('change', callback);

        for (var val in data) {
            $('<option />', { value: data[val], text: val }).appendTo(s);
        }

        return s;
    }

    if (mUI == 'Button') {
        mContent = ButtonCreate(mTitle, mCallBack);
        mContent.appendTo($("#" + aID));
    }

    function ButtonCreate(title, callback) {
        var b = $('<button/>').text(title).click(callback);
        return b;
    }
}

function showhideScheduleRules() {
    "use strict";
    var lValue = $(this.value).selector || 1;

    if (lValue == 1) { //Random
        $('#uSoberTrackDesignDuration').show();
        $('#uSoberTrackDesignTestsPerBlock').show();
        $('#uSoberTrackDesignTestPeriod').hide();
        $('#uSoberTrackDesignRetests').hide();
    }
    else if (lValue == 2) { //Fixed
        $('#uSoberTrackDesignDuration').hide();
        $('#uSoberTrackDesignTestsPerBlock').hide();
        $('#uSoberTrackDesignTestPeriod').hide();
        $('#uSoberTrackDesignRetests').hide();
    }
}

/*****************************************/
/*****Create Display Offender Alcohol*****/
/*****************************************/
function displayOffenderAlcoholSchedLiveBlock(aData, aTimezone, aViewStart, aViewEnd) {
    "use strict";
    var lData = aData;
    var lTimeZone = aTimezone;
    this.AppUserId = lData.AppUserId;
    this.EnrolleeId = lData.EnrolleeId;
    this.EnrolleeTimeZone = lTimeZone.TimeZoneName;
    this.ScheduleType = lData.ScheduleType;
    this.OrganizationId = lData.OrganizationId;
    this.DayOfWeek = lData.DayOfWeek;
    this.start = soberTrackCreateScheduleBlockStartDate(this.DayOfWeek, lData.StartHour, this.EnrolleeTimeZone, aViewStart, aTimezone);
    this.end = soberTrackCreateScheduleBlockStopDate(this.DayOfWeek, lData.StartHour, lData.StopHour, this.EnrolleeTimeZone, aViewStart, aTimezone);
    this.Name = lData.Name;
    this.durationEditable = false;    
    this.ScheduleTypeName = lData.ScheduleTypeName;
    this.color = getResultLiveColor(null, null, null, this.ScheduleType);
    this.textColor = "#000";
    this.StartHour = lData.StartHour;
    this.StopHour = lData.StopHour;
    this.Id = lData.Id;
    this.ConfirmFlag = lData.ConfirmFlag;
    this.IsActive = lData.IsActive;
    this.CurrentWeek = checkIfItIsCurrentWeek(aViewStart, aViewEnd);
    this.PastWeek = checkIfItIsPastWeek(aViewStart, aViewEnd);
    this.IsActiveMatters = false;
    this.DeletedDateBeforeDay = false;
    this.CreatedDateAfterDay = false;
    this.MaxNumberRetest = aData.MaxNumberRetest;

    if (this.ScheduleType == 101) {
        this.title = this.Name + " " + uScheduleDetailsCreateOnView(aData.NumberOfTest, aData.MinuteBetweenTest);
    } else {
        this.title = this.Name;
    }
    if (this.CurrentWeek) {
        this.CreatedDateAfterDay = checkIfDateCreatedIsAfterDayOfWeek(this.start, this.end, lData);
    }
    if (this.CurrentWeek) {
        //check if block is after current day
        if (nowIsBeforeBlock(this.start, this.end)) {
            //if blcok is after current day is it still active?
            if (!this.IsActive) {
                this.IsActiveMatters = true;
            }
        }

    }
    if (this.CurrentWeek) {
        this.DeletedDateBeforeDay = checkIfDateDeletedIsBeforeDayOfWeek(this.start, this.end, lData);
    }

    if (this.PastWeek) {
        this.CreatedDateAfterDay = checkIfDateCreatedIsAfterDayOfWeek(this.start, this.end, lData);
    }
}

function nowIsBeforeBlock(aStart, aEnd) {
    "use strict";
    var lStart = aStart,
        lEnd = aEnd,
        lNowMoment = moment(),
        lNow = lNowMoment._d;

    if (lNow < lStart) {
        return true;
    } else {
        return false;
    }
}

function checkIfDateDeletedIsBeforeDayOfWeek(aStart, aEnd, aData) {
    "use strict";
    var lTimezone = getEnrolleeTimeZone(aData.EnrolleeId);
    var lStart = moment(aStart)._d,
        lDeletedDate = moment(moment(aData.StopDateUTCString).tz(lTimezone.TimeZoneName).format())._d;

    if (lStart > lDeletedDate) {
        return true;
    } else {
        return false;
    }
}

function checkIfDateCreatedIsAfterDayOfWeek(aStart, aEnd, aData) {
    "use strict";
    var lTimezone = getEnrolleeTimeZone(aData.EnrolleeId);
    var lStart = moment(aStart)._d,
        lUpdatedDate = moment(moment(aData.StartDateUTCString).tz(lTimezone.TimeZoneName).format())._d;

    if (lStart < lUpdatedDate) {
        return true;
    } else {
        return false;
    }
}

function displayOffenderAlcoholSchedBlock(aData, aTimezone, aViewStart, aViewEnd) {
    "use strict";
    var lData = aData;
    var lTimeZone = aTimezone;
    this.NumberOfTest = lData.NumberOfTest;
    this.MinuteBetweenTest = lData.MinuteBetweenTest;
    this.AppUserId = lData.AppUserId;
    this.EnrolleeId = lData.EnrolleeId;
    this.EnrolleeTimeZone = lTimeZone.TimeZoneName;
    this.ScheduleType = lData.ScheduleType;
    this.OrganizationId = lData.OrganizationId;
    this.DayOfWeek = lData.DayOfWeek;
    this.start = soberTrackCreateScheduleBlockStartDate(this.DayOfWeek, lData.StartHour, this.EnrolleeTimeZone, aViewStart, aTimezone);
    this.end = soberTrackCreateScheduleBlockStopDate(this.DayOfWeek, lData.StartHour, lData.StopHour, this.EnrolleeTimeZone, aViewStart, aTimezone);
    //convert start to timezone display
    //convert end to timezone display
    this.Name = lData.Name;
    this.durationEditable = false;    
    this.ScheduleTypeName = lData.ScheduleTypeName;
    this.color = getResultLiveColor(null, null, null, this.ScheduleType);
    this.textColor = "#000";
    this.StartHour = lData.StartHour;
    this.StopHour = lData.StopHour;
    this.Id = lData.Id;
    this.StartDate = lData.StartDate;

    if (this.ScheduleType == 101) {
        this.title = this.Name + " " + uScheduleDetailsCreateOnView(this.NumberOfTest, this.MinuteBetweenTest);
    } else {
        this.title = this.Name;
    }
}

function uScheduleDetailsCreateOnView(aNumberOfTest, aMinuteBetweenTest) {
    "use strict";
    var lHourText = localizeText('cTimelineHour'),
        lDesignDurationSelect = aMinuteBetweenTest / 60;

    if (lDesignDurationSelect > 1) {
        lHourText = localizeText('cTimelineHourPlural');
    }

    var lDesignDuration = localizeText('cSoberTrackDurationBetweenTests') + ': ' + lDesignDurationSelect + ' ' + lHourText;
    var lTestsPerBlock = localizeText('cSoberTrackNumberTests') + ': ' + aNumberOfTest;
    var lScheduleDetails = '\n' + lDesignDuration + '\n' + lTestsPerBlock;
    return lScheduleDetails;
}


function soberTrackCreateScheduleBlockStartDate(aDayOfWeek, aStartHour, aEnrolleeTimeZone, aViewStart, aTimezone) {
    "use strict";
    var lDayOfWeek = getIndexOfDayOfWeek(aDayOfWeek),
        lStart = getSplitUpDaysDate(lDayOfWeek, aStartHour, aViewStart);

    return lStart._d;
}

function soberTrackCreateScheduleBlockStopDate(aDayOfWeek, aStartHour, aStopHour, aEnrolleeTimeZone, aViewStart, aTimezone) {
    "use strict";
    var lDayOfWeek = getIndexOfDayOfWeek(aDayOfWeek),
        lNextDay = getTotalOvernightTimes(lDayOfWeek, aStartHour, aStopHour),
        lStop = getSplitUpDaysDate(lNextDay, aStopHour, aViewStart);

    return lStop._d;
}

function getTotalOvernightTimes(aDayOfWeek, aStartHour, aStopHour) {
    "use strict";
    var lDayOfWeek = aDayOfWeek;
    if (parseInt(aStartHour) > parseInt(aStopHour)) {
        lDayOfWeek = lDayOfWeek + 1;
        return lDayOfWeek;
    } else {
        lDayOfWeek = lDayOfWeek + 0;
        return lDayOfWeek;
    }
}

function getSplitUpDaysDate(aDayOfWeek, aHour, aViewStart) {
    "use strict";
    var lViewStart = aViewStart.clone(),
        lTime = lViewStart.add(aDayOfWeek, 'days'),
        lStartHourInMin = splitByMinutes(aHour),
        lTime = lTime.add(lStartHourInMin, 'minutes'),
        lTime = lTime.add(getOffsetOfSaveDate(), 'minutes');

    return lTime;
}

function splitByMinutes(aHour) {
    "use strict";
    var lHour = aHour,
        lSplitTime = lHour.split(':'),
        lMinutes = (filterInt(lSplitTime[0]) * 60) + (filterInt(lSplitTime[1]));

    function filterInt(value) {
        if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
            return Number(value);
        return NaN;
    }

    return lMinutes;
}

function getIndexOfDayOfWeek(aDayOfWeek) {
    "use strict";
    switch (aDayOfWeek) {
        case "SUNDAY":
            return 0;
        case "MONDAY":
            return 1;
        case "TUESDAY":
            return 2;
        case "WEDNESDAY":
            return 3;
        case "THURSDAY":
            return 4;
        case "FRIDAY":
            return 5;
        case "SATURDAY":
            return 6;
    }
}

function getDayOfWeek(indexOfDay) {
    "use strict";
    switch (indexOfDay) {
        case 0:
            return "SUNDAY";
        case 1:
            return "MONDAY";
        case 2:
            return "TUESDAY";
        case 3:
            return "WEDNESDAY";
        case 4:
            return "THURSDAY";
        case 5:
            return "FRIDAY";
        case 6:
            return "SATURDAY";
    }
}

function displayOffenderAlcoholSchedule(aData, aTimezone, aImage) {
    "use strict";
    var lData = aData;
    var lTimeZone = aTimezone;
    this.ConfirmFlag = aData.ConfirmFlag;

    var overnightTest = soberTrackTestEventCrossesOverNight(displayFixedTimeZoneTime(lData.StartDate, lTimeZone.TimeZoneName), displayFixedTimeZoneTime(lData.StopDate, lTimeZone.TimeZoneName));

    if(overnightTest[0]){ //is overnight test
        this.start = overnightTest[1];
        this.end = overnightTest[2];
    } else {
        this.start = displayFixedTimeZoneTime(lData.StartDate, lTimeZone.TimeZoneName);
        this.end = displayFixedTimeZoneTime(lData.StopDate, lTimeZone.TimeZoneName);
    }

    this.AppUserId = lData.AppUserId;
    this.DurationBetweenTest = lData.DurationBetweenTest;
    this.EnrolleeId = lData.EnrolleeId;
    this.EnrolleeTimeZone = lTimeZone.TimeZoneName;
    this.NumberRetest = lData.NumberRetest;
    this.MaxNumberRetest = lData.MaxNumberRetest;
    this.ScheduleType = lData.ScheduleType;
    this.ScheduleTypeName = lData.ScheduleTypeName;
    this.StartDate = displayFixedTimeZoneTime(lData.StartDate, this.EnrolleeTimeZone);
    this.StopDate = displayFixedTimeZoneTime(lData.StopDate, this.EnrolleeTimeZone);
    this.TestPerDay = lData.TestPerDay;
    this.TestPeriod = lData.TestPeriod;
    this.Id = lData.Id;
    this.StatusId = lData.StatusId;
    this.StatusName = lData.StatusName;
    this.ScheduleId = lData.ScheduleId;
    //this.Name = lData.Name;
    this.Now = moment();
    this.EventStart = moment(this.start);
    this.durationEditable = false;
    this.ImageId = lData.ImageId;
    this.Bac = lData.Bac;
    this.BacLimit = lData.BacLimit;
    this.ImageMatchedFlag = getImageMatchDisplayScheduleDisplay(aImage);
    this.ImageVideoUrl = aImage.DeviceVideoUrl;
    this.title = 'test';
    //this.title = addPassOrFailStatus(this.StatusName, this.StatusId, this.Now, this.EventStart) + ' ' +  this.Name;
    //this.color = getResultLiveColor(this.StatusName, this.Now, this.EventStart, this.ScheduleType);   

    this.color = "#fff";
    this.borderColor = "#fff";

    for (var key in aImage) {
        if (aImage.hasOwnProperty(key)) {
            if (!isNullOrUndefined(aImage[key].DeviceVideoUrl) && aImage[key].DeviceVideoUrl != '') {
                this.color = "#757575";
                this.borderColor = "#757575";
                break;
            }
        }           
    } 
    
    
    this.textColor = getResultLiveTextColor(this.StatusName);
    this.startEditable = false;
    this.ConfirmedDate = displayFixedTimeZoneTime(lData.ConfirmedDate, this.EnrolleeTimeZone);
    this.ConfirmedByUserId = lData.ConfirmedByUserId;
}

function soberTrackTestEventCrossesOverNight(aStartDate, aStopDate) {
    "use strict";
    var lCurrentStartCompare = moment(aStartDate).clone(),
        lCurrentEndCompare = moment(aStartDate).clone(),
        lCurrentStartCompare = lCurrentStartCompare.set({
            'hour': 23,
            'minute': 29,
            'second': 59
        }),
        lCurrentEndCompare = lCurrentEndCompare.set({
            'hour': 23,
            'minute': 59,
            'second': 59
        });

    if (aStartDate <= lCurrentEndCompare && aStartDate > lCurrentStartCompare) {
        return [true, moment(aStartDate).add(30, 'minutes'), moment(aStopDate).add(30, 'minutes')];
    } else {
        return [false];
    }

}

function getImageMatchDisplayScheduleDisplay(aImage) {
    if (isNullOrUndefined(aImage[0])) {
        return null;
    } else {
        return aImage[0].ImageMatchedFlag;
    }
}

function soberTrackLiveEventCanBeEditable(aHasOccurred, aScheduleType) {
    "use strict";
    if (aHasOccurred) {
        return false;
    }

    return true;
}

function getResultLiveTextColor(aStatusName) {
    "use strict";
    if (!isNullOrUndefined(aStatusName)) {
        if (aStatusName == 'Failed') {
            return "#fff";
        } else {
            return "#fff";
        }
    }
}

function getResultBorderColorImage(aImage) {
    "use strict";
    if(!isNullOrUndefined(aImage)){
        if(aImage.ImageMatchedFlag == 0){
            return "#E50000"
        } else if(aImage.ImageMatchedFlag == 1) {
            return "#00CC00";
        } else {
            return "#000";
        }
    } else {
        return "";
    }
}

function getResultLiveColor(aStatusName, aNow, aEventStart, aScheduleType) {
    "use strict";
    if (aScheduleType == 101) {
        return "#f0f0f0";
    }

    if (aScheduleType == 501) {
        return "#3F5765";
    }

    if (!isNullOrUndefined(aStatusName)) {
        if (aStatusName == 'Passed') {
            return "#00CC00";
        } else {
            return "#E50000";
        }
    }
}

function addPassOrFailStatus(aStatusName, aStatusId, aNow, aEventStart) {
    "use strict";
    return aStatusName;
}

function displayOnDemandOffenderAlcoholSchedule(aData, aTimezone) {
    "use strict";
    var lData = aData;
    var lTimeZone = aTimezone;
    this.start = lData.StartDate;
    this.end = lData.StopDate;
    this.AppUserId = gUserDetails.UserId;
    this.DurationBetweenTest = -1;
    this.EnrolleeId = lData.EnrolleeId;
    this.EnrolleeTimeZone = lTimeZone.TimeZoneName;
    this.NumberRetest = -1;
    this.ScheduleType = lData.ScheduleType;
    this.StartDate = convertTimeToUTC(lData.StartDate.toDate(), this.EnrolleeTimeZone);
    this.StopDate = convertTimeToUTC(lData.StopDate.toDate(), this.EnrolleeTimeZone);
    this.TestPerDay = -1;
    this.TestPeriod = -1;
    this.Id = lData.Id;
    this.StatusId = lData.StatusId;
    this.Name = lData.title;
    this.Now = moment();
    this.EventStart = moment(this.start);

    this.title = addPassOrFailStatus(this.StatusId, this.Now, this.EventStart) + this.Name;
    this.color = getResultLiveColor(this.StatusId, this.Now, this.EventStart, this.ScheduleType);
    this.textColor = getResultLiveTextColor(this.ScheduleType);
    this.HasOccurred = getHasOccurredProperty(this.EventStart, this.Now);
    this.startEditable = soberTrackLiveEventCanBeEditable(this.HasOccurred, this.ScheduleType);
}

/*****************************************/
/**************Enrolleee Maps*************/
/*****************************************/
function enrolleesMapAlcoholMarker_OnClick(aSender, aEvent) {
    "use strict";
    var lPoint = aSender.sumoData.Data;

    if (!isNullOrUndefined(lPoint)) {
        uQuickReviewAlcoholMonitoring(lPoint);
    }
}

/** sobertrack control**/
function navigateToNextTest(aIndex) {
    var lDataSource = mEnrolleesData.SoberTrackResultsDirty.slice(),
        lIndex = aIndex,
        lSelectedIndex = mEnrolleesData.SoberTrackResultsDirty[lIndex - 1],
        lVideoAvailable = false,
        lStartIIndex = mEnrolleesData.SoberTrackResultsDirty[0];

        if (aIndex != 1) {
        lDataSource[0] = lSelectedIndex;
        lDataSource[lIndex - 1] = lStartIIndex;
    
    }
    
    mEnrolleesData.CurrentAlcoholResult = lSelectedIndex;
     
    if(lSelectedIndex.StatusId > 1) {
        $('.SobertrackDownloadVideoButton').addClass('ConsumerPreviewDisabled');
        $('.SobertrackRetrieveVideoButton').addClass('ConsumerPreviewDisabled');
        mEnrolleesControls.SoberTrackTestResultControl.PaginateNext(aIndex, lDataSource);
        mEnrolleesControls.SoberTrackTestResultControl.setModal(false);
        return
    }

    var currentImage = lSelectedIndex;

    if (!isNullOrUndefined(currentImage.DeviceVideoUrl) && currentImage.DeviceVideoUrl != '') {
        $('.SobertrackDownloadVideoButton').removeClass('ConsumerPreviewDisabled');
        $('.SobertrackRetrieveVideoButton').addClass('ConsumerPreviewDisabled');
        mEnrolleesData.CurrentAlcoholResult = currentImage;
        lVideoAvailable = true;
    }

    if (currentImage.VideoRequestedDateUTC == null) {
        currentImage.VideoRequestedDateUTC = new Date(0);
    }

    var minuteDifference = moment.duration(moment().diff(moment(currentImage.VideoRequestedDateUTC))).asMinutes()

    if (!lVideoAvailable && lSelectedIndex.DeviceImageUrl != "Images/NoPhoto.png" && (minuteDifference > 15)) {
        $('.SobertrackDownloadVideoButton').addClass('ConsumerPreviewDisabled');
        $('.SobertrackRetrieveVideoButton').removeClass('ConsumerPreviewDisabled');
    } else {
        if (!lVideoAvailable) {
            $('.SobertrackDownloadVideoButton').addClass('ConsumerPreviewDisabled');
            $('.SobertrackRetrieveVideoButton').removeClass('ConsumerPreviewDisabled');
            $('.SobertrackRetrieveVideoButton').addClass('Disabled');
        }
    }
    mEnrolleesControls.SoberTrackTestResultControl.PaginateNext(aIndex, lDataSource);
    mEnrolleesControls.SoberTrackTestResultControl.setModal(false);
}

function uOffenderSoberTrackSetUploadPhoto_OnClick() {
    "use strict";
    var lOffenderPhoto = new OffenderPhoto();
	var lClientSetting = veritracks.system.clientSetting("alcoholimagefolder");
	var lPrefix = lClientSetting.replace("Images/Mugshots/", "");
    lOffenderPhoto.EnrolleeId = mEnrolleesData.CurrentAlcoholImage.EnrolleeId;
    lOffenderPhoto.PhotoUri = lPrefix + mEnrolleesData.CurrentAlcoholImage.DeviceImageUrl;
    lOffenderPhoto.PhotoTypeId = 4;
    lOffenderPhoto.AlcoholImageId = mEnrolleesData.CurrentAlcoholImage.Id;
    WriteSingle(lOffenderPhoto, uOffenderSoberTrackSetUploadPhoto_OnSuccess, uOffenderSoberTrackSetUploadPhoto_OnFail, null);

}

function uOffenderSoberTrackSetUploadPhoto_OnSuccess(aParams, aData) {
    "use strict";
    if (!isNullOrUndefined(aData)) {
        if (isNullOrUndefined(mEnrolleesData.OffenderPhotosAlcohol) || mEnrolleesData.OffenderPhotosAlcohol.length == 0) {
            $('#uOffenderSoberTrackProfilePhoto').attr('src', "Images/Mugshots/" + aData.PhotoUri);
            //if (aData.PhotoTypeId == 4) {
             //   $('#uOffenderSoberTrackProfilePhoto').addClass("AlcoholUploadedImage");
             //   $('#uOffenderSoberTrackProfilePhoto').css("width", "auto");
            //}
            mEnrolleesData.OffenderPhotoIndexAlcohol = 0;
        }
        generateSoberTrackOffenderPhoto({ "EnrolleeId": aData.EnrolleeId });
    }
    mActivityNotification.addNotification('image added to profile');
}

function uOffenderSoberTrackSetUploadPhoto_OnFail() {
    "use strict";
    mActivityNotification.addNotification('note able to add image to profile');
}

function offenderAlcoholNotes_OnSuccess(aParam, aData) {
    "use stric";
    var lButtonBar = GenerateButtonCommandBar(),
        lHtml = [],
        lData = aData,
        lColumns = [],
        lPermissionId = 14,
        lTitle = localizeText('cEventViewNotes');

    FixDates(lData);
    mEnrolleesData.AlcoholNotesList = lData;
    lHtml.push('<div id="uSoberTrackReviewPopupHolderNotesViewer" style="height:100%;width:100%;">');
    lHtml.push('</div>');

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'disposeAlcoholNotesPopup()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeAddNewNote'), 'Add', 'AddAlcoholNotes()'));
    DisplayPopup(lTitle, lHtml.join(''), lButtonBar, true, false, null, true);

    mEnrolleesControls.AlcoholNotesManager = new SumoNotesManager('uAlcoholNotesListView', 'uSoberTrackReviewPopupHolderNotesViewer', lData, {
        'ClassName': 'Events',
        'IdentificationProperty': 'Id',
        'Identifier': mEnrolleesData.CurrentAlcoholSchedule.Id,
        'UserId': gUserDetails.UserId,
        'PermissionId': 32
    });

    mEnrolleesControls.AlcoholNotesManager.RenderContents();
    $('#uAlcoholNotesListView .ButtonBar').remove();


}

function disposeAlcoholNotesPopup() {
    "use strict";
    ClosePopup3();
    mEnrolleesData.OffenderAlcoholScheduleNoteContent = null;
    mEnrolleesData.AlcoholNotesList = null;

}

function AddAlcoholNotes() {
    var lButtonBar = GenerateButtonCommandBar(),
       lHtml = [],
       lTitle = localizeText('cEnrolleeAddNewNote');

    lHtml.push('<textarea id="uOffenderAlcoholScheduleNotesAdd" class="AddNoteTextArea" onchange="offenderAlcoholNotes_OnChange()"></textarea>')

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'closeOffenderAlcoholNotesAdd()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'AddOffenderAlcoholNotes_OnSave()'));
    DisplayPopup(lTitle, lHtml.join(''), lButtonBar, true, false, null, true);
}

function closeOffenderAlcoholNotesAdd() {
    "use strict";
    ClosePopup3();
    mEnrolleesData.OffenderAlcoholScheduleNoteContent = null;
    mEnrolleesData.AlcoholNotesList = null;
    notesSoberTrackReviewMonitoring();
}

function offenderAlcoholNotes_OnChange() {
    "use strict";
    mEnrolleesData.OffenderAlcoholScheduleNoteContent = $('#uOffenderAlcoholScheduleNotesAdd').val();
}

function AddOffenderAlcoholNotes_OnSave() {
    "use strict";
    var newNote = new OffenderAlcoholSchedNote(mEnrolleesData.CurrentAlcoholSchedule.Id),
        lNewNotes = [];

    newNote.Content = mEnrolleesData.OffenderAlcoholScheduleNoteContent;
    newNote.IsActive = true;
    newNote.UserId = gUserDetails.UserId;
    mEnrolleesData.OffenderAlcoholScheduleNoteContent = null;
    lNewNotes.push(newNote);

    WriteMultiple(lNewNotes, AddOffenderAlcoholNotes_OnSuccess, offenderAlcoholImage_OnFail);
}

function AddOffenderAlcoholNotes_OnSuccess(aParams, aData) {
    "use strict";
    var lData = aData,
        lNote = null;

    for (var key in aData) {
        if (lData.hasOwnProperty(key)) {
            lNote = lData[key];
            lNote.CreatedDateUTC = fixDate(lNote.CreatedDateUTC);
            mEnrolleesData.AlcoholNotesList.push(lNote);
        }
    }

    ClosePopup3();
    notesSoberTrackReviewMonitoring();
}

function notesSoberTrackReviewMonitoring() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();


    //if (isNullOrUndefined(mEnrolleesData.AlcoholNotesList)) {
     lBuilder.AddNewExpressionConditional("AlcoholScheduleId", mEnrolleesData.CurrentAlcoholSchedule.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
     lBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
     ReadMultiple(gObjectList.OffenderAlcoholSchedNote.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderAlcoholNotes_OnSuccess, offenderAlcoholImage_OnFail, null, null, 0, true);
    //} //else {
      //  offenderAlcoholNotes_OnSuccess(null, mEnrolleesData.AlcoholNotesList);
   // }



}

function navigateToPreviousEnrolleeResult() {
    "use strict";
    var lData = getDataItems('EnrolleeReport'),
       lLastEnrolleeId = null,
       lEnrolleeIds = [],
       lEnrollees = [],
       lBuilder = new SumoPredicateBuilder(),
       lSort = new SortExpression(),
       lSortPredicate = new SortExpression(),
       lScheduleSort = new SortExpression(),
       lFullData = getDataItems('FullEnrolleeReport'),
       lOffenderAlcoholSchedules = [],
       lSelectedAlcoholSchedule = null,
       lgenIcon = null,
       lEnrolleAlcoholSchedule = null;

    if (!isNullOrUndefined(lFullData)) {
        lData = lFullData;
    }

    lSortPredicate.addAscendingColumn('Id');
    lData = lSortPredicate.sort(lData);

    for (var key in lData) {
        if (lData.hasOwnProperty(key)) {

            if (lEnrolleeIds.indexOf(lData[key].Id) == -1) {
                lEnrolleeIds.push(lData[key].Id);
            }
        }//end of if
    }//end of for

    lBuilder.AddNewExpressionConditional("Id", lEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

    lEnrollees = query(getDataItems('Enrollees'), lBuilder.RootExpression);
    lScheduleSort.addAscendingColumn('LastName');
    lEnrollees = lScheduleSort.sort(lEnrollees);
    var isCurrentEnrollee = false;
    for (var key in lEnrollees) {
        if (lEnrollees.hasOwnProperty(key)) {
            if (mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId == lEnrollees[key].Id) {
                isCurrentEnrollee = true;
                break;
            }
            lgenIcon = gDashboardPage.dashboardSummaryReportIconAlcohol(lEnrollees[key].Id);

            if (lgenIcon != '' && !isCurrentEnrollee && mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId != lEnrollees[key].Id) {
                lLastEnrolleeId = lEnrollees[key].Id;
            }

        }//end of if
    }//end of if

    GetOffenderAlcoholSchedules(lLastEnrolleeId, -1, function (aParams, aData) {
        lBuilder.Clear();
        //lBuilder.AddNewExpressionConditional('EnrolleeId', lLastEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('StatusId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', [201, 301, 401], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lEnrolleAlcoholSchedule = query(aData, lBuilder.RootExpression);
        lSort.addDescendingColumn('StopDate');
        lEnrolleAlcoholSchedule = lSort.sort(lEnrolleAlcoholSchedule);

        for (var key in lEnrolleAlcoholSchedule) {
            if (lEnrolleAlcoholSchedule.hasOwnProperty(key)) {
                lSelectedAlcoholSchedule = lEnrolleAlcoholSchedule[key];
                break;
            }
        }//end of for

        gDashboardPage.selectFromDashboardListView(lLastEnrolleeId);
        SoberTrackReview_Init({ 'event': lSelectedAlcoholSchedule, 'isDashboard': true });
    }, function () {
        mActivityNotification.addNotification('No Data Found');
    });    
}

function navigateToNextEnrolleeResult() {
    "use strict";
    var lData = getDataItems('EnrolleeReport'),
       lLastEnrolleeId = null,
       lEnrolleeIds = [],
       lEnrollees = [],
       lBuilder = new SumoPredicateBuilder(),
       lSort = new SortExpression(),
       lSortPredicate = new SortExpression(),
       lScheduleSort = new SortExpression(),
       lFullData = getDataItems('FullEnrolleeReport'),
       lOffenderAlcoholSchedules = [],
       lSelectedAlcoholSchedule = null,
       lgenIcon = null,
       lEnrolleAlcoholSchedule = null;

    if (!isNullOrUndefined(lFullData)) {
        lData = lFullData;
    }

    lSortPredicate.addAscendingColumn('Id');
    lData = lSortPredicate.sort(lData);

    for (var key in lData) {
        if (lData.hasOwnProperty(key)) {

            if (lEnrolleeIds.indexOf(lData[key].Id) == -1) {
                lEnrolleeIds.push(lData[key].Id);
            }
        }//end of if
    }//end of for

    lBuilder.AddNewExpressionConditional("Id", lEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

    lEnrollees = query(getDataItems('Enrollees'), lBuilder.RootExpression);
    lScheduleSort.addAscendingColumn('LastName');
    lEnrollees = lScheduleSort.sort(lEnrollees);
    var isCurrentEnrollee = false;
    for (var key in lEnrollees) {
        if (lEnrollees.hasOwnProperty(key)) {
            if (mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId == lEnrollees[key].Id) {
                isCurrentEnrollee = true;
            }
            lgenIcon = gDashboardPage.dashboardSummaryReportIconAlcohol(lEnrollees[key].Id);

            if (lgenIcon != '' && isCurrentEnrollee && mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId != lEnrollees[key].Id) {
                lLastEnrolleeId = lEnrollees[key].Id;
                break;
            }

        }//end of if
    }//end of if

    
    GetOffenderAlcoholSchedules(lLastEnrolleeId, -1, function (aParams, aData) {
        lBuilder.Clear();
        //lBuilder.AddNewExpressionConditional('EnrolleeId', lLastEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('StatusId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ScheduleType', [201, 301, 401], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lEnrolleAlcoholSchedule = query(aData, lBuilder.RootExpression);
        lSort.addDescendingColumn('StopDate');
        lEnrolleAlcoholSchedule = lSort.sort(lEnrolleAlcoholSchedule);

        for (var key in lEnrolleAlcoholSchedule) {
            if (lEnrolleAlcoholSchedule.hasOwnProperty(key)) {
                lSelectedAlcoholSchedule = lEnrolleAlcoholSchedule[key];
                break;
            }
        }//end of for

        gDashboardPage.selectFromDashboardListView(lLastEnrolleeId);
        SoberTrackReview_Init({ 'event': lSelectedAlcoholSchedule, 'isDashboard': true });
    }, function () {
        mActivityNotification.addNotification('No Data Found');
    });
    
}

function navigateToPreviousEnrolleeResultSched() {
    "use strict";
    var lData = null,
      lScopy = [],
      lCount = 0,
      lCurrentIndex = 0,
      lSort = new SortExpression(),
      lNextScheduleSelected = null;

    lData = mEnrolleesControls.sobertracksLiveChart.getDataSource().slice(0);
    lSort.addAscendingColumn('StartDate');
    lData = lSort.sort(lData);

    for (var key in lData) {
        if (lData.hasOwnProperty(key)) {
            if (lData[key].ScheduleType != 501 && lData[key].ScheduleType != 101) {
                if (mEnrolleesData.CurrentAlcoholSchedule.Id == lData[key].Id) {
                    lCurrentIndex = lCount;
                }
                lScopy.push(lData[key]);
            }
            lCount++;
        }//end of if
    }//end of for

    lCurrentIndex--;
    lNextScheduleSelected = lScopy[lCurrentIndex];
    SoberTrackReview_Init({ 'event': lNextScheduleSelected, 'isDashboard': true });
}

function navigateToNextEnrolleeResultSched() {
    "use strict";
    var lData = null,
        lScopy = [],
        lCount = 0,
        lCurrentIndex = 0,
        lSort = new SortExpression(),
        lNextScheduleSelected = null;

    lData = mEnrolleesControls.sobertracksLiveChart.getDataSource().slice(0);
    lSort.addAscendingColumn('StartDate');
    lData = lSort.sort(lData);

    for (var key in lData) {
        if (lData.hasOwnProperty(key)) {
            if (lData[key].ScheduleType != 501 && lData[key].ScheduleType != 101) {
                if (mEnrolleesData.CurrentAlcoholSchedule.Id == lData[key].Id) {
                    lCurrentIndex = lCount;
                }
                lScopy.push(lData[key]);
            }
            lCount++;
        }//end of if
    }//end of for

    lCurrentIndex++;
    lNextScheduleSelected = lScopy[lCurrentIndex];
    SoberTrackReview_Init({ 'event': lNextScheduleSelected, 'isDashboard': true });

}

function enableLiveTileNavigationButtons() {
    "use strict";
    var lData = null,
        lScopy = [],
        lCount = 0,
        lSort = new SortExpression(),
        lCurrentIndex = 0;

    lData = mEnrolleesControls.sobertracksLiveChart.getDataSource().slice(0);
    lSort.addAscendingColumn('StartDate');
    lData = lSort.sort(lData);

    for (var key in lData) {
        if (lData.hasOwnProperty(key)) {
            if (lData[key].ScheduleType != 501 && lData[key].ScheduleType != 101) {
                if (mEnrolleesData.CurrentAlcoholSchedule.Id == lData[key].Id) {
                    lCurrentIndex = lCount;
                }
                lScopy.push(lData[key]);
            }
            lCount++;
        }//end of if
    }//end of for

    if (lScopy.length > 0) {
        if (lCurrentIndex == (lScopy.length - 1) && lScopy.length >= 2) {
            $('.NextButton').addClass('ConsumerPreviewDisabled');
            $('.PreviousButton').removeClass('ConsumerPreviewDisabled');
        } else if (lCurrentIndex == 0 && lScopy.length >= 2) {
            $('.NextButton').removeClass('ConsumerPreviewDisabled');
            $('.PreviousButton').addClass('ConsumerPreviewDisabled');
        } else {
            if (lScopy.length == 1) {
                $('.NextButton').addClass('ConsumerPreviewDisabled');
                $('.PreviousButton').addClass('ConsumerPreviewDisabled');
            } else {
                $('.NextButton').removeClass('ConsumerPreviewDisabled');
                $('.PreviousButton').removeClass('ConsumerPreviewDisabled');
            }
        }
    } else {
        $('.NextButton').addClass('ConsumerPreviewDisabled');
        $('.PreviousButton').addClass('ConsumerPreviewDisabled');
    }
}

function enableNaviationButtons(aEnrolleeId) {
    "use strict";

    var lData = getDataItems('EnrolleeReport'),
        lLastEnrolleeId = null,
        lCurrentIndex = 0,
        lPreviousIndex = 0,
        lTotalIndex = 0,
        lIsCurrentIndex = false,
        lNextIndex = 0,
        lEnrolleeIds = [],
        lBuilder = new SumoPredicateBuilder(),
        lEnrollees = [],
        lSortPredicate = new SortExpression(),
        lScheduleSort = new SortExpression(),
        lFullData = getDataItems('FullEnrolleeReport'),
        lOffenderAlcoholSchedules = [],
        lAlcoholAssignments = getDataItems('AlcoholDeviceAssignments'),
        lgenIcon = '',
        lDeviceAssignments = null,
        lSelectedDeviceAssingment = null,
        lSelectedAlcoholSchedule = null,
        lEnrolleAlcoholSchedule = null;


    if (!isNullOrUndefined(lFullData)) {
        lData = lFullData;
    }

    lSortPredicate.addAscendingColumn('Id');
    lData = lSortPredicate.sort(lData);

    for (var key in lData) {
        if (lData.hasOwnProperty(key)) {

            if (lEnrolleeIds.indexOf(lData[key].Id) == -1) {
                lEnrolleeIds.push(lData[key].Id);
            }
        }//end of if
    }//end of for

    lBuilder.AddNewExpressionConditional("Id", lEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

    lEnrollees = query(getDataItems('Enrollees'), lBuilder.RootExpression);
    lScheduleSort.addAscendingColumn('LastName');
    lEnrollees = lScheduleSort.sort(lEnrollees);


    for (var key in lEnrollees) {
        if (lEnrollees.hasOwnProperty(key)) {
            lgenIcon = gDashboardPage.dashboardSummaryReportIconAlcohol(lEnrollees[key].Id);

            if (!isNullOrUndefined(lgenIcon) && lgenIcon != '' && !lIsCurrentIndex) {
                lNextIndex++;
            }
            if (!isNullOrUndefined(lgenIcon) && lgenIcon != '' && !lIsCurrentIndex) {
                lCurrentIndex++;
            }
            if (mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId == lEnrollees[key].Id) {
                lIsCurrentIndex = true;
            }//end of if

            if (!isNullOrUndefined(lgenIcon) && lgenIcon != '' && !lIsCurrentIndex) {
                lPreviousIndex++;
            }

            if (!isNullOrUndefined(lgenIcon) && lgenIcon != '') {
                lTotalIndex++;
            }
        }//end of if
    }


    if (lTotalIndex == 1) {
        $('.NextButton').addClass('ConsumerPreviewDisabled');
        $('.PreviousButton').addClass('ConsumerPreviewDisabled');
    } else if (lCurrentIndex == lTotalIndex) {
        $('.NextButton').addClass('ConsumerPreviewDisabled');
        $('.PreviousButton').removeClass('ConsumerPreviewDisabled');
    } else if (lPreviousIndex == (lCurrentIndex - 1)){
        if (lTotalIndex >= 2) {
            $('.NextButton').removeClass('ConsumerPreviewDisabled');
        } else {
            $('.NextButton').addClass('ConsumerPreviewDisabled');
        }

        if (lCurrentIndex == 1) {
            $('.PreviousButton').addClass('ConsumerPreviewDisabled');
        } else {
            $('.PreviousButton').removeClass('ConsumerPreviewDisabled');
        }

    }
}

function uEnrolleesSoberTrackSchedulesListView_Init() {
    "use strict";

    mEnrolleesControls.SoberTrackSchedulesListView = new sumo.controls.ListView('uEnrolleesSchedulesListView', 'uEnrolleesSchedulesListViewHolder', {
        'keyField': 'Id', 'selectMethod': 'ctrlKey', 'cssClass': 'VeritracksListView', 'canUnselect': true, 'localization': true
    }, [
        { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
        { 'id': 'StartHour', 'title': localizeWrapper('cSoberTrackStartHour'), 'dataField': 'StartHour', 'width': 'autoData', 'minWidth': 85, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': formatTo12Hours },
        { 'id': 'StopHour', 'title': localizeWrapper('cSoberTrackStopHour'), 'dataField': 'StopHour', 'width': 'autoData', 'minWidth': 85, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatTo12Hours },
        { 'id': 'StartDate', 'title': localizeWrapper('cEnrolleeStartDate'), 'dataField': 'StartDateUTCString', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatSoberTrackEventDateTime },
        { 'id': 'Confirmed', 'title': localizeWrapper('cSoberTrackConfirmed'), 'dataField': 'Confirmed', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
        { 'id': 'DayOfWeek', 'title': localizeWrapper('cSoberTrackDayOfWeek'), 'dataField': 'DayOfWeek', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': null, 'canResize': false }
    ]);
    mEnrolleesControls.SoberTrackSchedulesListView.bind('selectedchanged', uSoberTrackSchedulesListView_OnSelectChange, null);
    mEnrolleesControls.SoberTrackSchedulesListView.bind('update', uSoberTrackSchedulesListView_Update);
    mEnrolleesControls.SoberTrackSchedulesListView.bind('sort', uSoberTrackSchedulesListView_OnSort);
}

function formatSoberTrackEventDateTime(aEvent) {
    "use strict";
    var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId),
        lResult;

    lResult = DisplayShortDateTime(displayEventInEnrolleeTimeZone(aEvent, lEnrollee));
    return lResult;
}

function EnrolleeProfileSoberTrackSchedules_Init(aEnrolleeId) {
    "use strict";
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId;

    getSoberTrackDesignEventSchedules_ListView(null, function (aOffenderAlcoholSchedBlock) {
        if (lEnrolleeId == mEnrolleesData.OffenderCurrentId) {
            mEnrolleesControls.SoberTrackSchedulesListView.setDataSource([]);
            var lOffenderAlcoholSchedBlock = aOffenderAlcoholSchedBlock.sort(function (a, b) {
                var lFirst = new Date(a.StartDateUTCString);
                var lSecond = new Date(b.StartDateUTCString)
                return lFirst - lSecond;
            });
            
            mEnrolleesControls.SoberTrackSchedulesListView.setDataSource(lOffenderAlcoholSchedBlock);
        }
        $('.loadingGif').hide();
    });

}


function getSoberTrackDesignEventSchedules_ListView(aParams, aCallback) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lEnrolleeSchedules = [],
        lKey,
        lEnrolleeId = mEnrolleesData.OffenderCurrentId;

    lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.OffenderAlcoholSchedBlock.AssemblyQualifiedName, lBuilder.RootExpression, 0, offenderAlcoholSchedBlock_OnSuccess, offenderAlcoholSchedBlock_OnFail, null, null, 0, true);

    function offenderAlcoholSchedBlock_OnSuccess(aParams, aData) {
        
        var lOffenderAlcoholSchedBlockDisplay = [];
        for (var i = 0; i < aData.length; i++) {
            if (aData[i].ScheduleType == 101 || aData[i].ScheduleType == 501) {
                var lOffenderAlcoholSchedBlock = new displayOffenderAlcoholSchedBlockListView(aData[i]);
                lOffenderAlcoholSchedBlock.durationEditable = false;
                lOffenderAlcoholSchedBlockDisplay.push(lOffenderAlcoholSchedBlock);
            }
        }

        if (aCallback) {
            aCallback(lOffenderAlcoholSchedBlockDisplay);
        }
    }

    function offenderAlcoholSchedBlock_OnFail(a, b) {
        //console.log(a, b);
    }
}

function displayOffenderAlcoholSchedBlockListView(aData, aTimeZone) {
    this.Id = aData.Id;
    this.Description = aData.Name;
    this.ScheduleTypeName = aData.ScheduleTypeName;
    this.ScheduleType = aData.ScheduleType;
    this.OrganizationId = aData.OrganizationId;
    this.EnrolleeId = aData.EnrolleeId;
    this.AppUserId = aData.AppUserId;
    this.TimeZone = aData.EnrolleeTimeZone;
    this.StartHour = aData.StartHour;
    this.StopHour = aData.StopHour;
    this.StartDate = aData.StartDate;
    this.StartDateUTCString = aData.StartDateUTCString;
    this.StopDate = aData.StopDate;
    this.Confirmed = displayIsConfirmed(aData.ConfirmFlag);
    this.DayOfWeek = aData.DayOfWeek;
}

function displayIsConfirmed(aConfirmFlag) {
    "use strict";
    var lResult = "No"
    if (aConfirmFlag) {
        lResult = "Yes";
    }

    return lResult;
}

function uSoberTrackSchedulesListView_OnSelectChange() {
    "use strict";
    var lSelectedLength = mEnrolleesControls.SoberTrackSchedulesListView.selected().length;

    if (lSelectedLength > 1) {
        $('#uDeleteSoberTrackScheduleButton').show();
    } else if (lSelectedLength === 1) {
        $('#uDeleteSoberTrackScheduleButton').show();
    } else {
        $('#uDeleteSoberTrackScheduleButton').hide();
    }

}

function uSoberTrackSchedulesListView_Update() {
    "use strict";
}

function uDeleteSoberTrackSchedule_OnClick() {
    var lSelectedIds = mEnrolleesControls.SoberTrackSchedulesListView.selected();
    var lScheduleBlockDelete = [];
    var lBlock;
    var lBlocksDataSource = mEnrolleesControls.SoberTrackSchedulesListView.getDataSource();

    if (lSelectedIds.length) {
        for (var i = 0; i < lSelectedIds.length; i++) {
            var lOffenderAlcoholSchedBlock = new OffenderAlcoholSchedBlock();
            lOffenderAlcoholSchedBlock.Id = lSelectedIds[i];

            lBlock = lBlocksDataSource.filter(function (a, i) {
                if (a.Id == lOffenderAlcoholSchedBlock.Id)
                    return a;
            })

            var lScheduleBlock = lBlock[i];

            lOffenderAlcoholSchedBlock.IsActive = 0;
            lOffenderAlcoholSchedBlock.StartDate = new Date(lScheduleBlock.StartDate);
            lOffenderAlcoholSchedBlock.StopDate = new Date(lScheduleBlock.StopDate);
            lOffenderAlcoholSchedBlock.AppUserId = lScheduleBlock.AppUserId;
            lOffenderAlcoholSchedBlock.EnrolleeId = lScheduleBlock.EnrolleeId;
            lOffenderAlcoholSchedBlock.EnrolleeTimeZone = lScheduleBlock.TimeZone;
            lOffenderAlcoholSchedBlock.ScheduleType = lScheduleBlock.ScheduleType;
            lOffenderAlcoholSchedBlock.OrganizationId = lScheduleBlock.OrganizationId;
            lOffenderAlcoholSchedBlock.DayOfWeek = lScheduleBlock.DayOfWeek;
            lOffenderAlcoholSchedBlock.StartHour = lScheduleBlock.StartHour;
            lOffenderAlcoholSchedBlock.StopHour = lScheduleBlock.StopHour;
            lOffenderAlcoholSchedBlock.Name = lScheduleBlock.Description;
            lOffenderAlcoholSchedBlock.NumberOfTest = 0;
            lOffenderAlcoholSchedBlock.MinuteBetweenTest = 0;
            lScheduleBlockDelete.push(lOffenderAlcoholSchedBlock);
        }
    }

    WriteMultiple(lScheduleBlockDelete, ClickDeleteScheduleBlocksListView_OnSuccess, ClickDeleteScheduleBlocks_OnFailure);

}

function ClickDeleteScheduleBlocksListView_OnSuccess(aParams, aData) {
    "use strict";
    var lTimezone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);
    var lAlcoholScheduleCommand = new AlcoholScheduleCommand();

    lAlcoholScheduleCommand.EnrolleeId = mEnrolleesData.OffenderCurrentId;
    lAlcoholScheduleCommand.EnrolleeTimeZone = lTimezone.TimeZoneName;

    WriteSingle(lAlcoholScheduleCommand, AlcoholScheduleCommandDeleteListView_OnSuccess, AlcoholScheduleCommandDelete_OnFailure);
}

function AlcoholScheduleCommandDeleteListView_OnSuccess(aScheduleType) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cSoberTrackEventDeleted'));
    EnrolleeProfileSoberTrackSchedules_Init(mEnrolleesData.OffenderCurrentId);
}


function uSoberTrackSchedulesListView_OnSort(aParams, aSort) {
    "use strict";

    var lSoberTrackSchedules = mEnrolleesControls.SchedulesListView.getDataSource(),
        lSoberTrackSchedulesList = [];

    lSoberTrackSchedulesList = aSort.sort(lSoberTrackSchedules);
    mEnrolleesControls.SoberTrackSchedulesListView.setDataSource(lSoberTrackSchedulesList);
}


function uSoberTrackNotificationButton_OnClick() {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', function () {
        var lSelected = $('#uSobertrackphoneSelect').val();
        var lSobertrackNotification = new SoberTrackNotification();
        var len = document.getElementById("uSobertrackphoneSelect").length;
        if (lSelected == "" && len <= 1) {
            mActivityNotification.addNotification('No Phone Number selected....')
            return
        }

        lSobertrackNotification.Id = mEnrolleesData.OffenderCurrentId;
        lSobertrackNotification.SMSNotificationPhoneNumber = lSelected;

        mActivityNotification.addNotification('Updating SoberTrack Phone Number....')
        WriteSingle(lSobertrackNotification, function () {
            ClosePopup();
            mActivityNotification.addNotification('Update Complete....')

        }, null)
    }));
    var lHtml = [
        '<h3> Enrollee SoberTrack phone select</h3>',
        '<select id="uSobertrackphoneSelect"></select>'
    ].join('')
    DisplayPopup('SoberTrack Notification Setup', lHtml, lButtonBar, false);


    var lBuilder = new SumoPredicateBuilder();


    lBuilder.AddNewExpressionConditional('Id', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.SobertrackNotification.AssemblyQualifiedName, lBuilder.RootExpression, 0, function (aParams, aData) {
        var lPhoneSelect = $('#uSobertrackphoneSelect');
        var lPhoneNumbers = [];
        var lData = aData[0];

        lPhoneSelect.empty();
        lPhoneSelect.append('<option value=""  >Select a Phone Number</option>');

        if (lData && lData.SMSNotificationPhoneNumber != "") {            
            lPhoneNumbers.push(lData.SMSNotificationPhoneNumber);
            lPhoneSelect.append('<option value="' + lData.SMSNotificationPhoneNumber + '" selected="true">' + lData.SMSNotificationPhoneNumber + '</option>');
        } 

        enrolleeAddress_Init(mEnrolleesData.OffenderCurrentId, function (aParams, aAddresses) {
            // add sms select options

            aAddresses.forEach(function (address) {
                if (address.PhoneNumber && lPhoneNumbers.indexOf(address.PhoneNumber) == -1) {
                    lPhoneNumbers.push(address.PhoneNumber)
                    lPhoneSelect.append('<option value="' + address.PhoneNumber + '">' + address.PhoneNumber + '</option>');
                }
                if (address.PhoneNumber2 && lPhoneNumbers.indexOf(address.PhoneNumber2) == -1) {
                    lPhoneNumbers.push(address.PhoneNumber2)
                    lPhoneSelect.append('<option value="' + address.PhoneNumber2 + '">' + address.PhoneNumber2 + '</option>');
                }
            })
        })

    }, Sad, null)
}

function getSobertrackVideoResults() {
    "use strict";
    var lImagePath = VERITRACKS_WEB_LOCAL + veritracks.system.clientSetting("alcoholimagefolder");
    $('#SobertrackVideoiFrame').attr('src', lImagePath + mEnrolleesData.CurrentAlcoholResult.DeviceVideoUrl);   
}

function onVideoRequestCommandOnSuccess(aParams, aData) {
    "use strict";    
    $('.SobertrackRetrieveVideoButton').removeClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveVideoButton').addClass('Disabled');
    $('#uSoberTrackTestVideoContentHolder').hide();
    $('#uSoberTrackTestResultContentHolder').show();   
    $('.SummaryButton').removeClass('ConsumerPreviewDisabled');
    $('.CloseButton').removeClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveSendVideoOkButton').addClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveSendVideoCancelButton').addClass('ConsumerPreviewDisabled');    
    mActivityNotification.addNotification(localizeWrapper('cSoberTrackVideoRequestSent'));
}

function onVideoRequestCommandOnFail(aParams, aData) {
    "use strict";  

    $('#uSoberTrackTestVideoContentHolder').hide();
    $('#uSoberTrackTestResultContentHolder').show();
    //$('.SobertrackRetrieveVideoButton').removeClass('ConsumerPreviewDisabled');
    $('.SummaryButton').removeClass('ConsumerPreviewDisabled');
    $('.CloseButton').removeClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveSendVideoOkButton').addClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveSendVideoCancelButton').addClass('ConsumerPreviewDisabled');

}

function disposeSobertrackRetrieve() {
    "use strict";

    $('#uSoberTrackTestVideoContentHolder').hide();
    $('#uSoberTrackTestResultContentHolder').show();    
    $('.SobertrackRetrieveVideoButton').removeClass('ConsumerPreviewDisabled');
    $('.SummaryButton').removeClass('ConsumerPreviewDisabled');
    $('.CloseButton').removeClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveSendVideoOkButton').addClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveSendVideoCancelButton').addClass('ConsumerPreviewDisabled');
    
}

function showRequestSoberTracakVideo() {
    "use strict";    
    if ($('.SobertrackRetrieveVideoButton').hasClass('Disabled')) {
       // mActivityNotification.addNotification(localizeWrapper('cSoberTrackVideoRequestSent'));
        return;
    }
    $('#uSoberTrackTestResultContentHolder').hide();
    $('#uSoberTrackTestVideoContentHolder').show();
    $('.SobertrackRetrieveVideoButton').addClass('ConsumerPreviewDisabled');
    $('.SummaryButton').addClass('ConsumerPreviewDisabled');
    $('.CloseButton').addClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveSendVideoOkButton').removeClass('ConsumerPreviewDisabled');
    $('.SobertrackRetrieveSendVideoCancelButton').removeClass('ConsumerPreviewDisabled');   
    
}

function sendRetrieveSobertrackVideoResults() {
    "use strict";
    var lTimeZone = getEnrolleeTimeZone(mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId);
   
    var lAlcoholVideoRequest = new AlcoholVideoCommand();
    lAlcoholVideoRequest.Id = mEnrolleesData.CurrentAlcoholResult.ImageId;
    lAlcoholVideoRequest.EnrolleeId = mEnrolleesData.CurrentAlcoholSchedule.EnrolleeId;
    lAlcoholVideoRequest.EnrolleeTimeZone = lTimeZone.TimeZoneName;
    lAlcoholVideoRequest.AppUserId = gUserDetails.UserId;

    
    WriteSingle(lAlcoholVideoRequest, onVideoRequestCommandOnSuccess, onVideoRequestCommandOnFail, [mEnrolleesData.CurrentAlcoholSchedule.Id + '' + lAlcoholVideoRequest.Id], true);

    
}


function generateSobertrackTestPhotoPopup(aThis) {
    "use strict";
    var html = [];

    html.push("<div>");
    html.push("<img id='popup" + mEnrolleesData.OffenderCurrentId + "' src=" + aThis.src + " style='height:500px;width: auto;margin-left:auto; margin-right:auto; display:block'/>");
    html.push("</div>");

    DisplayPopup("Photo", html.join(""), null, false, false, null, true)
    //resizeOffenderPhoto("popup" + mEnrolleesData.OffenderCurrentId);
}



/*
 * SoberTrack Summary 
 *
 */

function mStateManagerEnrolleesPrimarySoberTrackReview_Init(){
    //state function + mStateManager.Settings()[1] + '_Init'

    mEnrolleesData.IsSecondaryVisible = false;
    $('#uEnrolleesSecondaryContentHolder').hide('fast', resetContentHolders);
    $('#uEnrolleesSecondaryMenuPanel').hide();
    $('#uEnrolleesSecondaryContentPanel').hide();
    $('#uEnrolleesMainContentPanel .ButtonBar.ContentOverhead').hide();
    uEnrolleesSoberTrackReviewListView_Init();
}
function mStateManagerEnrolleesPrimarySoberTrackReview_OnComplete(){
    // console.log('On complete SoberTrackReview')
}
function mEnrolleesSoberTrackReviewLisView_OnClickCardView(){
    var EnrolleeId = mEnrolleesControls.CardView.selectedDataItem().Enrollee.Id;
    if(EnrolleeId){
        //GetSoberTrackDetailFromEnrolleeId(EnrolleeId)
        mEnrolleesData.OffenderAlcoholRetestMax = checkOrganizationProperty(Enrollee.OrganizationId, "alcohol_number_of_retests");
        mEnrolleesData.OffenderAlcoholRetestMax ++;
        $("#uEnrolleesSoberTrackLoadingBar").show()
        $("#uEnrolleesSoberTrackListViewHolder").hide()
        ReloadEnrolleeAlcoholSummary(EnrolleeId,function(aParams,aDataList){   
            $("#uEnrolleesSoberTrackLoadingBar").hide()
            $("#uEnrolleesSoberTrackListViewHolder").show()
            if(mEnrolleesControls.SoberTrackTestsListView){
                mEnrolleesControls.SoberTrackTestsListView.setDataSource(aDataList);
            }
        })
    }
}
function uEnrolleesSoberTrackReviewListView_OnSort(aParams, aSort) {
    "use strict";

    var lEnrolleeSchedules = mEnrolleesControls.SoberTrackTestsListView.getDataSource(),
        lEnrolleeSchedulesList = [];

    lEnrolleeSchedulesList = aSort.sort(lEnrolleeSchedules);
    mEnrolleesControls.SoberTrackTestsListView.setDataSource(lEnrolleeSchedulesList);
}
function uEnrolleesSoberTrackReviewListView_Init() {
    "use strict";
    if (isNullOrUndefined(mEnrolleesControls.SoberTrackTestsListView)) {
        var lColumns = [
            { 'id': 'Icon', 'title': '', 'dataField': 'IconId', 'width': 'autoData', 'minWidth': 60, 'sortable': false,  'dataType': null, 'formatMethod': EnrolleesSoberTrackTestIconFormatter },
            { 'id':'ScheduleTypeName','title':'Type','dataField':'ScheduleTypeName','width': 'autoData', 'minWidth': 45},
            { 'id': 'StartDate', 'title': 'Start Date','dataField':'StartDate', 'width': 'autoData', 'minWidth': 110, 'sortable': true, 'dataType': null, 'formatMethod': EnrolleesSoberTrackStartDateFormatter },
            { 'id': 'StopDate', 'title': ' Result Date', 'dataField': 'StopDate', 'width': 'autoData', 'minWidth': 110, 'sortable': true,'dataType': null, 'formatMethod': EnrolleesSoberTrackTestResultDateFormatter },
            { 'id': 'Status', 'title': 'Monitoring Result Status', 'dataField': 'StatusName', 'width': 'autoData', 'minWidth': 140, 'sortable': true, 'dataType': 'number', 'formatMethod': EnrolleesSoberTrackTestStatusFormatter },
            { 'id':'Bac','title':'BAC','dataField':'Bac','width': 'autoData', 'minWidth': 30,'formatMethod':function(aData,aParams){
                var lHideBAC = veritracks.core.GetOriProperty(aParams.OrganizationId, 'hide_bac_level');
                return lHideBAC && [0,2].indexOf(aParams['StatusId'])> -1 ? '-':parseInt(aData)/1000;// make it 3 digits
            }},
            { 'id':'Confirmed','title':'Confirmed','dataField':'ConfirmFlag','width': 'autoData', 'minWidth': 80,'formatMethod':sobertrackConfirmedTestFormatter},
            { 'id': 'Details', 'title': '', 'dataField': 'ScheduleId', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'dataType': 'auto', 'formatMethod': EnrolleesSoberTrackTestDetailsFormatter },
        ];
        mEnrolleesControls.SoberTrackTestsListView = new sumo.controls.ListView('uEnrolleesSoberTrackListView', 'uEnrolleesSoberTrackListViewHolder',{ 
            'cssClass': 'VeritracksListView', 
            'selectMethod': 'single',
            'scrollIntoView': false,
            'canUnselect': false
        }, lColumns);
        // mEnrolleesControls.SoberTrackTestsListView.bind('selectedchanged', );
        mEnrolleesControls.SoberTrackTestsListView.bind('sort', uEnrolleesSoberTrackReviewListView_OnSort);

    }
}
function ReloadEnrolleeAlcoholSummary(aEnrolleeId, aOnSuccess, aOnFailure, aParams) {
    "use strict";
    GetEnrolleeAlcoholSummary(aEnrolleeId, function (aParams, aData) {
        var lSort = new SortExpression();
        FixDates(aData);
        lSort.addDescendingColumn('StopDate');
        aData =lSort.sort(aData)
        mEnrolleesData.OffenderAlcoholSummary = aData;
        aOnSuccess(aParams, aData)
    }, aOnFailure, aParams)

}
function GetEnrolleeAlcoholSummary(aEnrolleeId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetAlcoholSummary', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aEnrolleeId': aEnrolleeId
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

//SoberTrack Instant reporting
function sobertrackInstantReporting_OnClick(aReportType) {
    "use strict";
    var lIncident = mAnalysisControls.CardView.selectedDataItem(),
        lAgentId,
        lOrganizationId = 0,
        lEnrolleesFilter = 0,
        lRiskLevel = 0;
    

    if (!isNullOrUndefined(lIncident)) {       
        lAgentId = getMyAgentIdsByOrganization(gUserDetails.UserId, [lIncident.OrganizationId])[0];

        if (aReportType == 0) {
            if (!isNullOrUndefined(mAnalysisControls.MatchesCardViewFilter)) {
                lOrganizationId = mAnalysisControls.MatchesCardViewFilter.columnValue('OrganizationId');
                if (lOrganizationId == '') {
                    lOrganizationId = 0;
                } else {
                    lOrganizationId = parseInt(lOrganizationId);
                }
            }

            if (!isNullOrUndefined(mAnalysisControls.MatchesCardView) && !isNullOrUndefined(mAnalysisControls.MatchesCardViewFilter)) {
                
                lEnrolleesFilter = mAnalysisControls.MatchesCardViewFilter.columnValue('EnrolleeName');
                lRiskLevel = mAnalysisControls.MatchesCardViewFilter.columnValue('RiskLevel');
            }
            CreateAnalysisResultInstantReport(lIncident.Id, lAgentId, lOrganizationId, lEnrolleesFilter, lRiskLevel);
        } else {
            //for other instant report in analysis tile
        }
        
    }
}

if (typeof exports !== 'undefined') {
    module.exports = {
        afterRender_SoberTracksLiveChart,
        soberTrackLiveStatusIconEvent
    };
}